import React, { useEffect, useRef, useState, useContext } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { formModes, alfrescoTypes, urls, formFieldTypes, vacationKinds, certificationKinds, actionTypes, hubEventTypes, customEventTypes, signStatuses, documentTabKeys, signTemplateActions, createTemplateActions, documentStatuses, UserContext, deliveryPlaceFields, deliveryPlaceValuesName, tripDestinations, settingsValueFieldTypes, transportationMethods, notificationTypes, formStringFieldPatterns, ukraineCountryValue, unstructuredDocumentKinds, transferRequestPositions, listTypes, juniorSalesConsultantPosition, routeCreatingTypes, attachmentTypes, businessTripAttachmentFileTypes } from '../../constants.js';
import DocumentHeader from './DocumentHeader.js';
import DocumentForm from './DocumentFofm.js';
import i18next from "../../i18n.js";
import CommentsForm from '../comments/CommentsForm.js';
import moment from 'moment';
import { unknownErrorMessageDialog, yesNoDialog, messageDialog, showModalDialog, hideModalDialog, deliveryPlaceDialog } from '../ModalDialog.js';
import FileContentForm from '../forms/FileContentForm.js';
import SignDocumentForm from '../forms/SignDocumentForm.js';
import { submitAction, showSignStatusMessage, getSignStatus, sendDocument, getWordWithCorrectEnding, loadListData } from '../helpers/HelperFunctions.js';
import ActionsMenu from '../menu/ActionsMenu.js';
import { CommentForm } from '../comments/CommentForm.js';
import { eventDispatcher } from '../../eventDispatcher.js';
import DocumentTabs from '../menu/DocumentTabs.js';
import { getComents, getElementByName, findField, initSelectFieldsValues, isDateOutOfRange, getResidenceDateRange, toDateLimit, updateCarInfoFiles } from './DocumentHelpers.js';
import FormNavigation from '../form/FormNavigation.js';
import RouteTypeSwitcher from '../forms/RouteTypeSwitcher.js';
import TripTaskForm from '../forms/TripTaskForm.js';
import { v4 } from 'uuid';
import { Spinner, Button } from 'react-bootstrap';
import { getDocumentTypeConfig } from './documentTypes/Registry.js';

const SendIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 4L3 11l6 2.5L21 4zM21 4l-4 16-3.5-8" />
    </svg>
);
const PencilIcon = () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 20h4l10-10-4-4L4 16v4z" />
        <path d="M13.5 6.5l4 4" />
    </svg>
);
// такий самий документ і шеврон, як у списку файлів підсумку відрядження
const DocIcon = () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 3h8l5 5v13H6V3z" />
        <path d="M14 3v5h5" />
    </svg>
);
const ChevronRightIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 6l6 6-6 6" />
    </svg>
);

// Наскільки прокрутка має піднятись вище за поле, щоб воно не сховалось під шапкою
// відрядження. Шапка враховується лише тоді, коли вона справді залипає вгорі: на інших
// документах її немає, а на великих екранах вона не sticky.
const stickyHeaderScrollGap = 12;
const getStickyHeaderOffset = () => {
    const stickyHeader = document.getElementsByClassName('business-trip-sticky')[0];
    if (!stickyHeader || getComputedStyle(stickyHeader).position !== 'sticky') return 0;
    return stickyHeader.offsetHeight + stickyHeaderScrollGap;
}

// Вкладені форми пункту маршруту мають існувати навіть тоді, коли в Alfresco їх ще немає:
// інакше підформа не має чого показати, і після вибору транспорту картка авто лишається порожньою.
// Стосується і транзитних зупинок — це такі самі пункти маршруту.
const initRouteSubForms = (form) => {
    if (!form.properties['carInfoForm']) {
        form.properties['carInfoForm'] = [{ type: 'sx:CarInfo', properties: {} }];
    }
    if (!form.properties['residenceStatusForm']) {
        form.properties['residenceStatusForm'] = [{ type: 'sx:ResidenceStatus', properties: {} }];
    }
    if (!form.properties['travelForm']) {
        form.properties['travelForm'] = [{ type: 'sx:TravelForm', properties: {} }];
    }
    // тип пального зберігається одним полем, а вибирається полем свого типу двигуна
    const carInfoForm = form.properties['carInfoForm'][0];
    if (carInfoForm.properties['sx:ciEngineType']) {
        carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`] = carInfoForm.properties['sx:ciFuelType'];
    }
    carInfoForm.properties['ownCarAttachments'] = [];
    carInfoForm.properties['rentalCarBillAttachments'] = [];
    carInfoForm.properties['rentalCarActAttachments'] = [];
}

const Document = (props) => {
    const [id, setId] = useState('');
    const [taskId, setTaskId] = useState('');
    const [formMode, setFormMode] = useState(props.formMode);
    const [needSign, setNeedSign] = useState(false);
    const [hasSignBtn, setHasSignBtn] = useState(false);
    const [saving, setSaving] = useState(false);
    const [signing, setSigning] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [canAddFiles, setCanAddFiles] = useState(false);
    const [tabKey, setTabKey] = useState(documentTabKeys.general);
    const [documentData, setDocumentData] = useState({});
    const [limitsInfo, setLimitsInfo] = useState(null);
    const [isTask, setIsTask] = useState(false);
    const [attachmentAdded, setAttachmentAdded] = useState(false);
    const [comments, setComments] = useState([]);
    const [mainContent, setMainContent] = useState(null);
    const [navigationIndex, setNavigationIndex] = useState(0);
    const [removedRouteForms, setRemovedRouteForms] = useState([]);
    const [removedOperationForms, setRemovedOperationForms] = useState([]);
    const [removedReportForms, setRemovedReportForms] = useState([]);
    const [removedResultForms, setRemovedResultForms] = useState([]);
    const [removedDocs, setRemovedDocs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [documentWasUpdated, setDocumentWasUpdated] = useState(false);
    // поле, на якому впала перевірка форми: { fieldName }. Новий об'єкт на кожну невдалу
    // перевірку, щоб групи вкладок реагували навіть на повторну ту саму помилку
    const [formError, setFormError] = useState(null);
    //const [showGoingBack, setShowGoingBack] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const userContext = useContext(UserContext);

    const documentIdRef = useRef('');
    const signingRef = useRef(false);

    const nowDate = new Date();

    // Дати маршрутів існують лише в межах дат відрядження: виїзд кожного наступного маршруту
    // не раніше за попередній, приїзд не раніше за виїзд, повернення не раніше останнього
    // виїзду. Усе, що в ці межі не вкладається, скидається — інакше користувач не побачив би,
    // що дата стала недопустимою. Виїзд скидається разом із приїздом, бо той залежить від нього.
    const applyTripDateLimits = (documentData, previousData) => {
        const tripStartDate = documentData.properties['sx:btDateStart'];
        const tripEndDate = documentData.properties['sx:btDateEnd'];
        const routeForms = documentData.properties['routeForm'] ?? [];
        const goingBackForms = documentData.properties['goingBackForm'] ?? [];

        // sx:pbtDate/sx:pbtDateEnd не мають власних контролів, але зберігаються в Alfresco
        if (routeForms.length > 0 && routeForms[0].properties['sx:pbtDate'] !== tripStartDate) {
            routeForms[0].properties['sx:pbtDate'] = tripStartDate;
            routeForms[0].properties['wasUpdated'] = true;
        }
        if (goingBackForms.length > 0 && goingBackForms[0].properties['sx:pbtDateEnd'] !== tripEndDate) {
            goingBackForms[0].properties['sx:pbtDateEnd'] = tripEndDate;
            goingBackForms[0].properties['wasUpdated'] = true;
        }

        let minDate = tripStartDate;
        [...routeForms, ...goingBackForms].forEach(form => {
            const travelForm = form.properties['travelForm']?.[0];
            if (!travelForm) return;

            if (isDateOutOfRange(travelForm.properties['sx:tfDepartureDate'], minDate, tripEndDate)) {
                travelForm.properties['sx:tfDepartureDate'] = '';
                travelForm.properties['sx:tfArrivalDate'] = '';
                travelForm.properties['wasUpdated'] = form.properties['wasUpdated'] = true;
            }
            const departureDate = travelForm.properties['sx:tfDepartureDate'];
            if (isDateOutOfRange(travelForm.properties['sx:tfArrivalDate'], departureDate || minDate, tripEndDate)) {
                travelForm.properties['sx:tfArrivalDate'] = '';
                travelForm.properties['wasUpdated'] = form.properties['wasUpdated'] = true;
            }
            if (isDateOutOfRange(form.properties['dateStartBack'], departureDate || minDate, tripEndDate)) {
                form.properties['dateStartBack'] = '';
                form.properties['wasUpdated'] = true;
            }
            if (departureDate) minDate = departureDate;
        });

        // Проживання можливе лише всередині відрізка свого маршруту, а той щойно міг змінитись,
        // тому перевіряємо його після дат поїздки.
        const multipleRoutes = documentData.properties['sx:btMultipleRoutes'];
        const previousRouteForms = previousData?.properties['routeForm'] ?? [];
        const previousGoingBackForms = previousData?.properties['goingBackForm'] ?? [];
        const previousMultipleRoutes = previousData?.properties['sx:btMultipleRoutes'];

        // За замовчуванням проживання займає весь відрізок маршруту, тому щойно межа відрізка
        // змінилась — вона підставляється в дати заселення й виселення. Поки межі ті самі,
        // введені вручну дати лишаються недоторканими: скидається тільки те, що вже не
        // вкладається в межі, причому заселення — разом із виселенням, бо межа виселення
        // залежить від заселення.
        const applyResidenceLimits = (form, previousForm, range, previousRange) => {
            const residenceForm = form.properties['residenceStatusForm']?.[0];
            if (!residenceForm) return;
            const properties = residenceForm.properties;
            const markUpdated = () => { residenceForm.properties['wasUpdated'] = form.properties['wasUpdated'] = true; };

            const from = toDateLimit(range.from);
            const to = toDateLimit(range.to);

            // Форма проживання щойно з'явилась — сам маршрут чи зупинка додані або ввімкнули
            // проживання в готелі. Обидві межі підставляються навіть якщо не змінювались:
            // інакше, наприклад, у щойно доданої останньої зупинки виселення лишилось би
            // порожнім, бо дата «Назад» маршруту з того часу не рухалась.
            const fillBothDates = !previousForm
                || (form.properties['sx:btAccommodationRequired'] && !previousForm.properties['sx:btAccommodationRequired']);

            if (fillBothDates || from !== toDateLimit(previousRange.from)) {
                properties['sx:rsArrivalDate'] = from ?? '';
                markUpdated();
            }
            if (fillBothDates || to !== toDateLimit(previousRange.to)) {
                properties['sx:rsDepartureDate'] = to ?? '';
                markUpdated();
            }

            if (isDateOutOfRange(properties['sx:rsArrivalDate'], from, to)) {
                properties['sx:rsArrivalDate'] = from ?? '';
                properties['sx:rsDepartureDate'] = to ?? '';
                markUpdated();
            }
            if (isDateOutOfRange(properties['sx:rsDepartureDate'], properties['sx:rsArrivalDate'] || from, to)) {
                properties['sx:rsDepartureDate'] = to ?? '';
                markUpdated();
            }
        }

        // дата зупинки дублюється у власний travelForm, тому очищати треба обидві
        const clearTransitDate = (transitForm) => {
            transitForm.properties['transitDate'] = '';
            const transitTravelForm = transitForm.properties['travelForm']?.[0];
            if (transitTravelForm) {
                transitTravelForm.properties['sx:tfDepartureDate'] = '';
                transitTravelForm.properties['wasUpdated'] = true;
            }
            transitForm.properties['wasUpdated'] = true;
        }

        // вікно проживання транзитної зупинки: від її дати до дати наступної зупинки,
        // а для останньої — до кінця відрізка маршруту
        const getTransitResidenceRange = (transitForms, transitIndex, routeRange) => ({
            from: transitForms[transitIndex]?.properties['transitDate'] || routeRange.from,
            to: transitForms[transitIndex + 1]?.properties['transitDate'] || routeRange.to
        });

        routeForms.forEach((form, index) => {
            const range = getResidenceDateRange(routeForms, index, goingBackForms, multipleRoutes);
            const previousRange = getResidenceDateRange(previousRouteForms, index, previousGoingBackForms, previousMultipleRoutes);
            applyResidenceLimits(form, previousRouteForms[index], range, previousRange);

            // Транзитні зупинки йдуть по черзі в тому самому вікні, що й маршрут. Спочатку
            // нормалізуємо дати самих зупинок, і лише потім проживання — воно спирається на
            // дату наступної зупинки, яка теж могла щойно скинутись.
            const transitForms = form.properties['transitForm'] ?? [];
            let transitMinDate = range.from;
            transitForms.forEach(transitForm => {
                if (isDateOutOfRange(transitForm.properties['transitDate'], transitMinDate, range.to)) {
                    clearTransitDate(transitForm);
                }
                const transitDate = transitForm.properties['transitDate'];
                if (transitDate) transitMinDate = transitDate;
            });

            const previousTransitForms = previousRouteForms[index]?.properties['transitForm'] ?? [];
            transitForms.forEach((transitForm, transitIndex) => {
                applyResidenceLimits(transitForm, previousTransitForms[transitIndex],
                    getTransitResidenceRange(transitForms, transitIndex, range),
                    getTransitResidenceRange(previousTransitForms, transitIndex, previousRange));
            });
        });
    }

    const getDocumentContext = (type) => {
        switch (type) {
            case alfrescoTypes.vacationClaim:
                return { formMode, limitsInfo, hasSignBtn, setCanAddFiles, updateDateValues };
            case alfrescoTypes.certification:
                return { formMode, userContext, mainContent };
            case alfrescoTypes.travelLetterAuto:
                return { formMode };
            case alfrescoTypes.businessTrip:
                return { userContext, navigationIndex, location };
            case alfrescoTypes.advanceReport:
                return { formMode };
            case alfrescoTypes.transferRequest:
                return { formMode };
            case alfrescoTypes.unstructuredDocument:
                return { };
            default:
                return {};
        }
    }

    const updateFields = (documentData) => {
        const typeConfig = getDocumentTypeConfig(documentData.type);
        if (typeConfig) {
            typeConfig.updateFields(documentData, getDocumentContext(documentData.type));
        }
    }

    const inputChangeHandler = (e, updatedFields = []) => {
        setDocumentWasUpdated(true);
        const { name, value, checked } = e.target;
        const newValue = e.target.type === 'checkbox' ? checked : value;
        if (name === 'cm:content') {
            if (newValue?.length > 0) {
                setMainContent(newValue);
                if (documentData.associations?.mainContent?.length > 0 && !documentData.associations.mainContent.some(nodeRef => nodeRef === newValue[0].nodeRef)) {
                    documentData.properties['assoc:sx:mainContent_removed'] = documentData.associations.mainContent.join(',');
                    documentData.associations.mainContent = [];
                }
                documentData.properties['cm:content'] = newValue;
            }
            else {
                setMainContent(null);
                documentData.properties['cm:content'] = null;
                if (documentData.associations?.mainContent?.length > 0) {
                    documentData.properties['assoc:sx:mainContent_removed'] = documentData.associations.mainContent.join(',');
                    documentData.associations.mainContent = [];
                }
            }
        }
        else {
            if (name === 'startingPoint' && newValue) {
                const mainPlace = newValue['sx:btMainPlace'];
                const city = mainPlace ? newValue['sx:btCityReturn'] : newValue['sx:btReasonWorkPlace'];
                if (documentData.properties['goingBackForm']?.length > 0) {
                    const travelForm = documentData.properties['goingBackForm'][0].properties['travelForm'];
                    if (travelForm?.length > 0) {
                        travelForm[0].properties['sx:tfPointArrival'] = city;
                        travelForm[0].properties['wasUpdated'] = true;
                        documentData.properties['goingBackForm'][0].properties['wasUpdated'] = true;
                    }
                }
                if (documentData.properties['routeForm']?.length > 0) {
                    const travelForm = documentData.properties['routeForm'][0].properties['travelForm'];
                    if (travelForm?.length > 0) {
                        travelForm[0].properties['sx:tfPoint'] = city;
                        travelForm[0].properties['wasUpdated'] = true;
                        documentData.properties['routeForm'][0].properties['wasUpdated'] = true;
                    }
                }
            }
            if ((name === 'routeForm' || name === 'goingBackForm') && value?.length < documentData.properties[name].length) {
                const removedItem = documentData.properties[name].find(item => item.nodeRef && (!value || !value.find(valueItem => valueItem.nodeRef === item.nodeRef)));
                if (removedItem) {
                    setRemovedRouteForms(prevValue => { prevValue.push(removedItem.nodeRef); return prevValue; })
                }
            }
            if (name === 'goingBackForm' && value?.length === 1 && documentData.properties[name].length === 0) {
                if (documentData.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad) {
                    if (documentData.properties['sx:btMainPlace']) {
                        value[0].properties['sx:pbtCity'] = documentData.properties['sx:btCityReturn'] ?? '';
                    }
                    else {
                        value[0].properties['sx:pbtCity'] = documentData.properties['sx:btReasonWorkPlace'] ?? '';
                    }
                    value[0].properties['sx:pbtCountryBusinessTrip'] = ukraineCountryValue; //Ukraine
                }
                else {
                    if (documentData.properties['sx:btMainPlace']) {
                        value[0].properties['sx:pbtExactDestination'] = documentData.properties['sx:btCityReturn'] ?? '';
                        value[0].properties['sx:pbtLocality'] = documentData.properties['sx:btCityReturn'] ?? '';
                    }
                    else {
                        value[0].properties['sx:pbtExactDestination'] = documentData.properties['sx:btReasonWorkPlace'] ?? '';
                    }
                }
                const lastRoute = documentData.properties['routeForm'].at(-1);
                value[0].properties['sx:pbtDate'] = lastRoute?.properties['sx:pbtDateEnd'];
                value[0].properties['sx:pbtDateEnd'] = documentData.properties['sx:btDateEnd'];

                if (lastRoute.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar) {
                    value[0].properties['sx:pbtMethodTransportation'] = transportationMethods.ownCar;
                    const lastRouteCarInfo = lastRoute.properties['carInfoForm']?.length > 0 ? lastRoute.properties['carInfoForm'][0] : null;
                    if (lastRouteCarInfo) {
                        value[0].properties['carInfoForm'][0] = structuredClone(lastRouteCarInfo);
                    }
                }
            }
            if (name === 'operationForm' && documentData.properties[name]?.length > 0 && value?.length < documentData.properties[name].length) {
                const removedItem = documentData.properties[name].find(item => item.nodeRef && (!value || !value.find(valueItem => valueItem.nodeRef === item.nodeRef)));
                if (removedItem) {
                    setRemovedOperationForms(prevValue => { prevValue.push(removedItem.nodeRef); return prevValue; })
                }
            }
            if (name === 'reportForm' && documentData.properties[name]?.length > 0 && value?.length < documentData.properties[name].length) {
                const removedItem = documentData.properties[name].find(item => item.nodeRef && (!value || !value.find(valueItem => valueItem.nodeRef === item.nodeRef)));
                if (removedItem) {
                    setRemovedReportForms(prevValue => { prevValue.push(removedItem.nodeRef); return prevValue; })
                }
            }
            if (name === 'resultForm' && documentData.properties[name]?.length > 0 && value?.length < documentData.properties[name].length) {
                const removedItem = documentData.properties[name].find(item => item.nodeRef && (!value || !value.find(valueItem => valueItem.nodeRef === item.nodeRef)));
                if (removedItem) {
                    setRemovedResultForms(prevValue => { prevValue.push(removedItem.nodeRef); return prevValue; })
                }
            }
            if ((name === 'sx:btBusinessTripDestination') && documentData.properties['routeForm']?.length > 0) {
                documentData.properties['routeForm'].forEach(form => {
                    form.properties['wasUpdated'] = true;
                });
                documentData.properties['goingBackForm'].forEach(form => {
                    form.properties['wasUpdated'] = true;
                });
            }
            if (name === 'documents' && documentData.type === alfrescoTypes.businessTrip) {
                const currentDocs = [];
                if (documentData.properties[name]?.children?.length > 0) {
                    documentData.properties[name].children.filter(c => c.isFolder && c.hasChildren).forEach(child => {
                        if (child.folderContent?.children?.length > 0) {
                            child.folderContent.children.filter(c => !c.isFolder && c.nodeRef).forEach(item => currentDocs.push(item));
                        }
                    });
                }
                const updatedDocs = [];
                if (newValue?.children?.length > 0) {
                    newValue.children.filter(c => c.isFolder && c.hasChildren).forEach(child => {
                        if (child.folderContent?.children?.length > 0) {
                            child.folderContent.children.filter(c => !c.isFolder && c.nodeRef).forEach(item => updatedDocs.push(item));
                        }
                    });
                }
                const forRemove = currentDocs.filter(doc => !updatedDocs.some(d => d.nodeRef === doc.nodeRef)).map(item => item.nodeRef);
                if (forRemove.length > 0) {
                    setRemovedDocs(removedDocs.concat(forRemove));
                }
            }
            if (documentData.type === alfrescoTypes.transferRequest) {
                if (name === 'sx:trSubordinate' || name === 'assoc:sx:trSubordinate_added') {
                    if (newValue) {
                        const filter = [];
                        if (name === 'sx:trSubordinate') {
                            filter.push({
                                name: 'UserName',
                                values: [newValue]
                            });
                        }
                        else {
                            filter.push({
                                name: 'Id',
                                values: [newValue.split('/').pop()]
                            });
                        }
                        loadListData(listTypes.Users, filter, 0, 1).then(data => {
                            if (data && data.items && data.items.length > 0) {
                                const currentData = data.items[0];

                                const transferDataSectionField = documentData.form.fields.find(f => f.name === 'transferDataSection');
                                const transferDataFromSectionField = transferDataSectionField.fields.find(f => f.name === 'transferDataFromSection');

                                const jobEmploymentLabel = currentData.fields.find(f => f.name === 'JobEmployment')?.value;
                                const fromRateField = transferDataFromSectionField.fields.find(f => f.name === 'sx:trFromRate');
                                const currentFromRateFieldValue = fromRateField.values.data.find(it => it.label.startsWith(jobEmploymentLabel));
                                documentData.properties['sx:trFromRate'] = currentFromRateFieldValue?.value;

                                const positionLabel = currentData.fields.find(f => f.name === 'Position')?.value;
                                const fromOfficeField = transferDataFromSectionField.fields.find(f => f.name === 'sx:frFromOffice');
                                const currentFromOfficeValue = fromOfficeField.values.data.find(it => it.label == positionLabel);
                                documentData.properties['sx:frFromOffice'] = currentFromOfficeValue?.value;

                                documentData.properties['sx:frTTFrom'] = currentData.fields.find(f => f.name === 'ShopNumber')?.value;
                                documentData.properties['sx:trFromStore'] = `shop_${documentData.properties['sx:frTTFrom']}`;
                                documentData.properties['sx:frRegion'] = `region_${documentData.properties['sx:frTTFrom']}`;

                                const userPhone = currentData.fields.find(f => f.name === 'Phone')?.value;
                                if (userPhone) {
                                    documentData.properties['sx:frPhoneNumber'] = userPhone;
                                }

                                const updatedData = structuredClone(documentData);
                                updatedData.properties[name] = newValue;
                                updateFields(updatedData);
                                setDocumentData(updatedData);
                            }
                            else {
                                documentData.properties['sx:frRegion'] = '';
                                documentData.properties['sx:frTTFrom'] = '';
                                documentData.properties['sx:trFromStore'] = '';
                                documentData.properties['sx:frFromOffice'] = '';
                                documentData.properties['sx:trFromRate'] = '';
                                const updatedData = structuredClone(documentData);
                                updatedData.properties[name] = newValue;
                                updateFields(updatedData);
                                setDocumentData(updatedData);
                            }
                        });
                    }
                    else {
                        documentData.properties['sx:frRegion'] = '';
                        documentData.properties['sx:frTTFrom'] = '';
                        documentData.properties['sx:trFromStore'] = '';
                        documentData.properties['sx:frFromOffice'] = '';
                        documentData.properties['sx:trFromRate'] = '';
                    }
                }
                if (name === 'sx:frTTTO') {
                    if (newValue) {
                        documentData.properties['sx:trToStore'] = `shop_${newValue}`;
                    }
                    else {
                        documentData.properties['sx:trToStore'] = '';
                    }
                }
            }
            if (name === 'methodTransportationForAll') {
                const routes = documentData.properties['routeForm'];
                if (routes?.length > 0) {
                    routes.forEach(routeForm => {
                        routeForm.properties['sx:pbtMethodTransportation'] = newValue;
                        routeForm.properties['wasUpdated'] = true;
                    });
                }
                // форми повернення може не бути (наприклад, у заявці, збереженій до її появи),
                // а без перевірки виняток обривав би обробник — і транспорт не потрапляв би
                // у маршрути взагалі
                const backRoute = documentData.properties['goingBackForm']?.[0];
                if (backRoute) {
                    backRoute.properties['sx:pbtMethodTransportation'] = newValue;
                    backRoute.properties['wasUpdated'] = true;
                }
                if (newValue === transportationMethods.ownCar && documentData.properties['assoc:sx:btSeconded_added'] === userContext?.nodeRef
                    && userContext?.userCarInfo) {
                    const carInfoFormForAll = documentData.properties['carInfoForm_forAll']?.[0];
                    if (carInfoFormForAll) {
                        carInfoFormForAll.properties['sx:ciBrandCar'] = userContext.userCarInfo.brand;
                        carInfoFormForAll.properties['sx:ciRegNumerInfo'] = userContext.userCarInfo.number;
                        carInfoFormForAll.properties['sx:ciReleaseYear'] = userContext.userCarInfo.releaseYear;
                        carInfoFormForAll.properties['sx:ciEngineType'] = userContext.userCarInfo.engineType;
                        carInfoFormForAll.properties['sx:ciEngineDisplacement'] = userContext.userCarInfo.engineVolume;
                        carInfoFormForAll.properties['sx:ciCarColor'] = userContext.userCarInfo.color;
                        if (userContext.userCarInfo.engineType) {
                            carInfoFormForAll.properties[`sx:ciFuelType_${userContext.userCarInfo.engineType}`] = userContext.userCarInfo.fuelType;
                        }
                    }
                }
                if (newValue === transportationMethods.carRental || !value) {
                    documentData.properties['carInfoForm_forAll'] = [{ type: 'sx:CarInfo', properties: {} }];
                }
            }
            if (name === 'routeForm' && newValue?.length > documentData.properties['routeForm']?.length) {
                if (documentData.properties["sx:btSameTransportForRoutes"]) {
                    const lastRoute = newValue.at(-1);
                    lastRoute.properties['sx:pbtMethodTransportation'] = documentData.properties['methodTransportationForAll'];
                }
            }
            const updatedData = structuredClone(documentData);
            // such fields keep the values of all the fields from their settings in one object
            if (name === deliveryPlaceValuesName || settingsValueFieldTypes.includes(findField(updatedData.form.fields, name)?.type)) {
                Object.keys(newValue ?? {}).forEach(fieldName => updatedData.properties[fieldName] = newValue[fieldName]);
            }
            else updatedData.properties[name] = newValue;
            // зміна будь-якого поля може зробити дати маршрутів недопустимими: і зміна дат
            // відрядження, і зміна дат чи складу самих маршрутів
            if (updatedData.type === alfrescoTypes.businessTrip) {
                // documentData — стан до зміни, за ним видно, чи зрушились межі відрізків
                applyTripDateLimits(updatedData, documentData);
            }
            if ((name === 'routeForm' || name === 'goingBackForm') && updatedFields.length === 1 && updatedFields[0].name === 'sx:pbtMethodTransportation') {
                const updatedRouteForm = updatedData.properties[name][updatedFields[0].index];
                if (updatedRouteForm?.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar) {
                    const carInfoForm = updatedRouteForm?.properties['carInfoForm']?.length > 0 ? updatedRouteForm.properties['carInfoForm'][0] : null;
                    if (carInfoForm && (!carInfoForm.properties['ownCarAttachments'] || carInfoForm.properties['ownCarAttachments'].length === 0)) {
                        carInfoForm.properties['ownCarAttachments'] = [];
                        updateCarInfoFiles(updatedData, carInfoForm.properties['ownCarAttachments'])
                            .then(added => { if (added) setDocumentData(current => ({ ...current })); });
                    }
                }
            }
            if (name === 'routeForm' && updatedFields.length === 2 && updatedFields[0].name === 'sx:pbtMethodTransportation' && updatedFields[1].name === 'transitForm') {
                const updatedRouteForm = updatedData.properties[name][updatedFields[1].index];
                const updatedTransitForm = updatedRouteForm?.properties['transitForm']?.[updatedFields[0].index];
                if (updatedTransitForm?.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar) {
                    const carInfoForm = updatedTransitForm?.properties['carInfoForm']?.length > 0 ? updatedTransitForm.properties['carInfoForm'][0] : null;
                    if (carInfoForm && (!carInfoForm.properties['ownCarAttachments'] || carInfoForm.properties['ownCarAttachments'].length === 0)) {
                        carInfoForm.properties['ownCarAttachments'] = [];
                        updateCarInfoFiles(updatedData, carInfoForm.properties['ownCarAttachments'])
                            .then(added => { if (added) setDocumentData(current => ({ ...current })); });
                    }
                }
            }
            if (name === 'routeForm' && updatedFields.length === 1 && updatedFields[0].name === 'sx:pbtBackMethodTransportation') {
                const updatedRouteForm = updatedData.properties[name][updatedFields[0].index];
                if (updatedRouteForm?.properties['sx:pbtBackMethodTransportation'] === transportationMethods.ownCar) {
                    const carInfoForm = updatedRouteForm?.properties['carInfoBackForm']?.length > 0 ? updatedRouteForm.properties['carInfoBackForm'][0] : null;
                    if (carInfoForm && (!carInfoForm.properties['ownCarAttachments'] || carInfoForm.properties['ownCarAttachments'].length === 0)) {
                        carInfoForm.properties['ownCarAttachments'] = [];
                        updateCarInfoFiles(updatedData, carInfoForm.properties['ownCarAttachments'])
                            .then(added => { if (added) setDocumentData(current => ({ ...current })); });
                    }
                }
            }
            if (name === 'routeForm' && updatedFields.length === 1 && updatedFields[0].name === 'sx:pbtSameTransportBack') {
                const updatedRouteForm = updatedData.properties[name][updatedFields[0].index];
                if (!updatedRouteForm.properties['sx:pbtSameTransportBack'] && updatedRouteForm?.properties['sx:pbtBackMethodTransportation'] === transportationMethods.ownCar) {
                    const carInfoForm = updatedRouteForm?.properties['carInfoBackForm']?.length > 0 ? updatedRouteForm.properties['carInfoBackForm'][0] : null;
                    if (carInfoForm && (!carInfoForm.properties['ownCarAttachments'] || carInfoForm.properties['ownCarAttachments'].length === 0)) {
                        carInfoForm.properties['ownCarAttachments'] = [];
                        updateCarInfoFiles(updatedData, carInfoForm.properties['ownCarAttachments'])
                            .then(added => { if (added) setDocumentData(current => ({ ...current })); });
                    }
                }
            }
            if (name === 'methodTransportationForAll' && newValue === transportationMethods.ownCar) {
                const carInfoForm = updatedData.properties['carInfoForm_forAll']?.length > 0 ? updatedData.properties['carInfoForm_forAll'][0] : null;
                if (carInfoForm && (!carInfoForm.properties['ownCarAttachments'] || carInfoForm.properties['ownCarAttachments'].length === 0)) {
                    carInfoForm.properties['ownCarAttachments'] = [];
                    updateCarInfoFiles(updatedData, carInfoForm.properties['ownCarAttachments'])
                        .then(added => { if (added) setDocumentData(current => ({ ...current })); });
                }
            }
            updateFields(updatedData);
            setDocumentData(updatedData);

            // деякі місця доставки потребують уточнення адреси, тому запитуємо її діалогом
            if (name === 'sx:btDeliveryPlace' && deliveryPlaceFields[newValue]) {
                deliveryPlaceDialog(deliveryPlaceFields[newValue],
                    (values) => inputChangeHandler({ target: { name: deliveryPlaceValuesName, value: { ...values, [name]: newValue } } }),
                    () => inputChangeHandler({ target: { name: name, value: '' } }));
            }
        }
    }

    const onTabChanged = (tabKey) => {
        if (loading) return;
        setTabKey(tabKey);
    }

    const updateDateValues = (minDate) => {
        let needUpdate = false
        const updatedData = structuredClone(documentData);
        const startDateField = updatedData.form.fields.find(f => f.name === 'sx:claimDateStart');
        const endDateField = updatedData.form.fields.find(f => f.name === 'sx:claimDateEnd');
        const startDate = updatedData.properties['sx:claimDateStart'] ? new Date(updatedData.properties['sx:claimDateStart']) : null;
        const endDate = updatedData.properties['sx:claimDateEnd'] ? new Date(updatedData.properties['sx:claimDateEnd']) : null;

        if (new Date(startDateField.minValue) < minDate) {
            startDateField.minValue = moment(minDate).format("YYYY-MM-DD");
            needUpdate = true;
        }
        if (new Date(endDateField.minValue) < minDate) {
            endDateField.minValue = moment(minDate).format("YYYY-MM-DD");
            needUpdate = true;
        }

        if (startDate && startDate < minDate) {
            updatedData.properties['sx:claimDateStart'] = '';
            endDateField.minValue = moment(minDate).format("YYYY-MM-DD");
            needUpdate = true;
        }
        if (endDate && endDate < minDate) {
            updatedData.properties['sx:claimDateEnd'] = '';
            needUpdate = true;
        }
        if (needUpdate) {
            updateFields(updatedData);
            setDocumentData(updatedData);
        }
    }

    const checkInputPage = () => {
        let checkResult = {
            result: true,
        };

        const typeConfig = getDocumentTypeConfig(documentData.type);
        if (typeConfig && typeConfig.checkInputPage) {
            checkResult = typeConfig.checkInputPage(documentData, getDocumentContext(documentData.type));
        }
        if (!checkResult.result) {
            setNavigationIndex(checkResult.nIndex);
            // групи вкладок відкривають вкладку, на якій лежить поле з помилкою
            setFormError(checkResult.errorElementName ? { fieldName: checkResult.errorElementName } : null);
            if (checkResult.errorElementName) {
                // поле може бути ще не відмальоване або лежати на неактивній вкладці,
                // тому чекаємо на нього обмежений час, а не безкінечно
                let attemptsLeft = 25;
                const scrollToElement = () => {
                    const errorElement = getElementByName(checkResult.errorElementName);
                    if (errorElement) {
                        // У відрядженні шапка з кроками залипає вгорі, тому поле, прокручене
                        // до верху контейнера, ховається під нею — прокручуємо вище на її
                        // висоту. Висота береться з самої шапки, а не задається числом, бо
                        // залежить від того, чи показується перемикач видів маршруту.
                        // На інших документах шапки немає, а на великих екранах вона не
                        // sticky — там відступ лишається нульовим і прокрутка не змінюється.
                        errorElement.style.scrollMarginTop = `${getStickyHeaderOffset()}px`;
                        errorElement.scrollIntoView({ behavior: "smooth" });
                    }
                    else if (attemptsLeft-- > 0) {
                        setTimeout(scrollToElement, 200);
                    }
                }
                setTimeout(scrollToElement, 350);
            }
            if (checkResult.errorElementId) {
                const errorElement = document.getElementById(checkResult.errorElementId);
                if (errorElement) {
                    errorElement.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
        else {
            setFormError(null);
        }
        return { success: checkResult.result, errorElementName: checkResult.errorElementName, nIndex: checkResult.nIndex };
    }

    const getAttachments = () => {
        if (documentData.type === alfrescoTypes.businessTrip) {
            if (documentData.properties['attachments']?.length > 0) {
                const attachedFiles = documentData.properties['attachments'].filter(a => !a.nodeRef && a.type === attachmentTypes.file).map(a => a.value);
                return attachedFiles;
            }
            return [];
        }
        else {
            return documentData.properties['sx:attachments'] ? documentData.properties['sx:attachments'].filter(a => !a.nodeRef).map(a => a.file) : []
        }
    }
    const getPassportAttachments = () => {
        if (documentData.type === alfrescoTypes.businessTrip) {
            if (documentData.properties['passportAttachments']?.length > 0) {
                const attachedFiles = documentData.properties['passportAttachments'].filter(a => !a.nodeRef && a.type === attachmentTypes.file).map(a => a.value);
                return attachedFiles;
            }
        }
        return [];
    }

    const submit = async (onSuccess) => {
        setLoading(true);
        setSaving(true);
        const contentBody = {
            properties: JSON.stringify(configueProps(documentData).properties),
            type: documentData.type,
            attachments: getAttachments(),
            passportAttachments: getPassportAttachments(),
            mainContent: mainContent && mainContent.length > 0 ? mainContent[0].file : null
        };
        fetch(`/api/Document/${formMode === formModes.create ? "Add" : "Update"}/${formMode !== formModes.create ? id : ""}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(contentBody)
        })
            .then(async (response) => {
                if (response.ok) {
                    const returnParam = searchParams.get('return');
                    if (!id) {
                        const result = await response.json();
                        if (result.nodeRef) {
                            const docId = result.nodeRef.split('/').pop();
                            if (docId) {
                                if (onSuccess) {
                                    onSuccess(docId);
                                }
                                else {
                                    navigate(`${urls.documentsPage}/${docId}?return=${returnParam ? returnParam : urls.documentsPage}`);
                                }
                            }
                            else {
                                unknownErrorMessageDialog();
                            }
                        }
                        else {
                            unknownErrorMessageDialog();
                        }
                    }
                    else {
                        if (onSuccess) {
                            onSuccess(id);
                        }
                        else {
                            if (isTask) {
                                navigate(`${urls.tasksPage}/${taskId}?docId=${id}&return=${returnParam ? returnParam : urls.tasksPage}`);
                            }
                            else {
                                navigate(`${urls.documentsPage}/${id}?return=${returnParam ? returnParam : urls.documentsPage}`);
                            }
                        }
                    }
                }
                else if (response.status !== 500 && response.status !== 401) {
                    unknownErrorMessageDialog();
                    setSaving(false);
                    setLoading(false);
                }
            })
            .catch(err => {
                console.error(err);
                unknownErrorMessageDialog();
                setSaving(false);
                setLoading(false);
            });
    }

    const configueProps = (documentData) => {
        const data = structuredClone(documentData);

        for (const [key] of Object.entries(data.properties)) {
            const field = data.form.fields.find(f => f.name === key);
            if (field) {
                if (field.visible === false && key !== 'sx:claimeDaysSum' && key !== 'sx:btHomeBack' && key !== 'goingBackForm' && key !== 'sx:btMultipleRoutes') {
                    delete data.properties[key];
                }
                if (field.type === formFieldTypes.datetime && !data.properties[key]) {
                    delete data.properties[key];
                }
                if (key === 'assoc:sx:ctSubordinate_added') {
                    if (data.associations?.subordinate?.length > 0) {
                        const subordinate = data.associations.subordinate[0];
                        if (subordinate === data.properties[key]) {
                            delete data.properties[key];
                        }
                        else {
                            data.properties['assoc:sx:ctSubordinate_removed'] = subordinate;
                        }
                    }
                }
                if (key === 'assoc:sx:btSeconded_added') {
                    if (data.associations?.seconded?.length > 0) {
                        const seconded = data.associations.seconded[0];
                        if (seconded === data.properties[key]) {
                            delete data.properties[key];
                        }
                        else {
                            data.properties['assoc:sx:btSeconded_removed'] = seconded;
                        }
                    }
                }
                if (key === 'assoc:sx:trSubordinate_added') {
                    if (data.associations?.seconded?.length > 0) {
                        const transferSubordinate = data.associations.transferSubordinate[0];
                        if (transferSubordinate === data.properties[key]) {
                            delete data.properties[key];
                        }
                        else {
                            data.properties['assoc:sx:trSubordinate_removed'] = transferSubordinate;
                        }
                    }
                }
            }
        }
        if (data.type === alfrescoTypes.vacationClaim) {
            if (data.associations?.additionalDocuments?.length > 0) {
                const forRemove = data.associations.additionalDocuments.filter(item => !data.properties['sx:attachments'] || !data.properties['sx:attachments'].some(a => a.nodeRef === item));
                data.properties['assoc:sx:additionalFiles_removed'] = forRemove.join(',');
            }
        }
        if (data.type === alfrescoTypes.certification && !data.properties['sx:ctCertificationForSubordinate']) {
            delete data.properties['assoc:sx:ctSubordinate_added'];
            delete data.properties['sx:ctSubordinate'];
            if (data.associations?.subordinate?.length > 0) {
                data.properties['assoc:sx:ctSubordinate_removed'] = data.associations.subordinate[0];
            }
        }
        if (data.type === alfrescoTypes.certification && data.properties['sx:dfDocKind'] === certificationKinds.characteristic
            && (formMode === formModes.edit || formMode === formModes.create)
            && mainContent && mainContent.length > 0
            && !documentData.associations?.mainContent?.some(nodeRef => nodeRef === mainContent[0].nodeRef)) {
            data.properties['assoc:sx:mainContent_0_filename'] = mainContent[0].file.fileName;
            data.properties['assoc:sx:mainContent_0_filedata'] = mainContent[0].file.content.split('base64,')[1];
            data.properties['assoc:sx:mainContent_0_extension'] = mainContent[0].file.fileName.split('.').pop();

            if (data.associations?.mainContent && data.associations.mainContent.length > 0) {
                data.properties['assoc:sx:mainContent_removed'] = data.associations.mainContent.join(',');
            }
        }
        if (data.type === alfrescoTypes.businessTrip) {
            delete data.properties['routeFormMain'];
            delete data.properties['sx:btDateStartMain'];
            delete data.properties['sx:btDateEndMain'];

            if (data.properties['sx:btMainPlace']) {
                delete data.properties['sx:btReason'];
                delete data.properties['sx:btReasonWorkPlace'];
            }
            else {
                delete data.properties['sx:btWorkPlace'];
                delete data.properties['sx:btCityReturn'];
            }
            if (removedDocs.length > 0) {
                data.properties['documentsRemoved'] = removedDocs;
            }

            delete data.properties['links'];
            if (data.properties['attachments']?.length > 0) {
                const links = data.properties['attachments'].filter(a => a.type === attachmentTypes.link && !a.nodeRef)
                    .map(a => ({
                        type: 'sx:link', properties: {
                            'sx:linkText': a.value,
                        }
                    }));
                data.properties['links'] = links;
            }
            if (data.associations?.links?.length > 0) {
                const forRemove = data.associations.links.filter(item => !data.properties['attachments'] || !data.properties['attachments'].some(a => a.nodeRef === item));
                data.properties['assoc:sx:links_removed'] = forRemove.join(',');
            }
            if (data.associations?.businessTripAdditionalFiles?.length > 0) {
                const forRemove = data.associations.businessTripAdditionalFiles.filter(item =>
                    (!data.properties['attachments'] || !data.properties['attachments'].some(a => a.nodeRef === item)) &&
                    (!data.properties['passportAttachments'] || !data.properties['passportAttachments'].some(a => a.nodeRef === item))
                );
                data.properties['assoc:sx:businessTripAdditionalFiles_removed'] = forRemove.join(',');
            }
            delete data.properties['attachments'];
            delete data.properties['passportAttachments'];
            delete data.properties['businessTripFiles'];

            if (formMode === formModes.create) {
                delete data.properties['routeForm'];
            }
            else {
                if (data.properties['routeForm']?.length > 0) {
                    if (data.properties['routeForm'].length > 1 && (data.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad || !data.properties['sx:btMultipleRoutes'])) {
                        const rest = data.properties['routeForm'].slice(1);
                        const forRemove = rest.filter(item => item.nodeRef && !removedRouteForms.includes(item.properties.nodeRef));
                        removedRouteForms.push(...forRemove.map(item => item.nodeRef));
                        data.properties['routeForm'] = [data.properties['routeForm'][0]];
                    }

                    // чи переписані нижче дати першого маршруту датами відрядження
                    let routeDatesCopied = false;
                    if (data.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad && data.properties['sx:btRouteType'] === routeCreatingTypes.auto) {
                        delete data.properties['goingBackForm'];
                    }
                    else {
                        if ((data.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad || !data.properties['sx:btMultipleRoutes']) && data.properties['routeForm'][0].properties['sx:pbtSameTransportBack']) {
                            const routeForm = data.properties['routeForm'][0];
                            if (routeForm.properties['wasUpdated']) {
                                if (!(data.properties['goingBackForm']?.length > 0)) {
                                    data.properties['goingBackForm'] = [{
                                        type: 'sx:PlaceBusinessTrip',
                                        properties: {
                                            'travelForm': [{ type: 'sx:TravelForm', properties: {} }],
                                            'sx:btAccommodationRequired': false,
                                            'sx:pbtReturnHome': true
                                        }
                                    }];
                                }
                                const goingBackForm = data.properties['goingBackForm'][0];

                                goingBackForm.properties['sx:pbtMethodTransportation'] = routeForm.properties['sx:pbtMethodTransportation'];
                                if (routeForm.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar || routeForm.properties['sx:pbtMethodTransportation'] === transportationMethods.carRental) {
                                    if (routeForm.properties['carInfoForm']?.length > 0) {
                                        if (!goingBackForm.properties['carInfoForm'] || goingBackForm.properties['carInfoForm'].length === 0) {
                                            goingBackForm.properties['carInfoForm'] = [{ type: 'sx:CarInfo', properties: {} }];
                                        }
                                        const backCarInfoForm = goingBackForm.properties['carInfoForm'][0];
                                        const carInfoForm = routeForm.properties['carInfoForm'][0];
                                        backCarInfoForm.properties['sx:ciBrandCar'] = carInfoForm.properties['sx:ciBrandCar'];
                                        backCarInfoForm.properties['sx:ciRegNumerInfo'] = carInfoForm.properties['sx:ciRegNumerInfo'];
                                        backCarInfoForm.properties['sx:ciReleaseYear'] = carInfoForm.properties['sx:ciReleaseYear'];
                                        backCarInfoForm.properties['sx:ciEngineType'] = carInfoForm.properties['sx:ciEngineType'];
                                        backCarInfoForm.properties['sx:ciEngineDisplacement'] = carInfoForm.properties['sx:ciEngineDisplacement'];
                                        backCarInfoForm.properties['sx:ciCarColor'] = carInfoForm.properties['sx:ciCarColor'];
                                        if (carInfoForm.properties['sx:ciEngineType']) {
                                            backCarInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`] = carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`];
                                        }
                                        backCarInfoForm.properties['wasUpdated'] = true;
                                    }
                                }
                                if (routeForm.properties['sx:pbtMethodTransportation'] === transportationMethods.corporateCar) {
                                    goingBackForm.properties['sx:ciBrandCar'] = routeForm.properties['sx:ciBrandCar'];
                                    goingBackForm.properties['sx:ciRegNumerInfo'] = routeForm.properties['sx:ciRegNumerInfo'];
                                    goingBackForm.properties['sx:ciModelCar'] = routeForm.properties['sx:ciModelCar'];
                                }
                                delete goingBackForm.properties['assoc:sx:pbtColleague_added'];
                                if (routeForm.properties['sx:pbtMethodTransportation'] === transportationMethods.autoColleagues) {
                                    if (!goingBackForm.associations?.colleague?.includes(routeForm.properties['assoc:sx:pbtColleague_added'])) {
                                        goingBackForm.properties['assoc:sx:pbtColleague_added'] = routeForm.properties['assoc:sx:pbtColleague_added'];
                                        if (goingBackForm.associations?.colleague?.length > 0) {
                                            goingBackForm.properties['assoc:sx:pbtColleague_removed'] = goingBackForm.associations.colleague.join(',');
                                        }
                                    }
                                }
                                else {
                                    if (goingBackForm.associations?.colleague?.length > 0) {
                                        goingBackForm.properties['assoc:sx:pbtColleague_removed'] = goingBackForm.associations.colleague.join(',');
                                    }
                                }

                                const travelForm = routeForm.properties['travelForm'][0];
                                if (navigationIndex === 1) {
                                    travelForm.properties['sx:tfDepartureDate'] = data.properties['sx:btDateStart'];
                                    travelForm.properties['sx:tfArrivalDate'] = data.properties['sx:btDateEnd'];
                                    travelForm.properties['wasUpdated'] = true;
                                    routeDatesCopied = true;
                                }

                                const backTravelForm = goingBackForm.properties['travelForm'][0];
                                backTravelForm.properties['sx:tfPoint'] = travelForm.properties['sx:tfPointArrival'];
                                backTravelForm.properties['sx:tfPointArrival'] = data.properties['sx:btMainPlace'] ? data.properties['sx:btCityReturn'] : data.properties['sx:btReasonWorkPlace'];
                                backTravelForm.properties['sx:tfDepartureDate'] = travelForm.properties['sx:tfArrivalDate'];
                                backTravelForm.properties['sx:tfArrivalDate'] = data.properties['sx:btDateEnd'];
                                backTravelForm.properties['sx:tfPreferredDepartureTime'] = '';
                                backTravelForm.properties['wasUpdated'] = true;

                                goingBackForm.properties['wasUpdated'] = true;
                            }
                        }
                        if ((data.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad || !data.properties['sx:btMultipleRoutes']) && !data.properties['routeForm'][0].properties['sx:pbtSameTransportBack']) {
                            const routeForm = data.properties['routeForm'][0];
                            if (routeForm.properties['wasUpdated']) {
                                if (!(data.properties['goingBackForm']?.length > 0)) {
                                    data.properties['goingBackForm'] = [{
                                        type: 'sx:PlaceBusinessTrip',
                                        properties: {
                                            'travelForm': [{ type: 'sx:TravelForm', properties: {} }],
                                            'sx:btAccommodationRequired': false,
                                            'sx:pbtReturnHome': true
                                        }
                                    }];
                                }
                                const goingBackForm = data.properties['goingBackForm'][0];

                                goingBackForm.properties['sx:pbtMethodTransportation'] = routeForm.properties['sx:pbtBackMethodTransportation'];
                                if (goingBackForm.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar || goingBackForm.properties['sx:pbtMethodTransportation'] === transportationMethods.carRental) {
                                    goingBackForm.properties['carInfoForm'] = routeForm.properties['carInfoBackForm'];
                                }
                                if (goingBackForm.properties['sx:pbtMethodTransportation'] === transportationMethods.corporateCar) {
                                    goingBackForm.properties['sx:ciBrandCar'] = routeForm.properties['sx:ciBrandCarBack'];
                                    goingBackForm.properties['sx:ciRegNumerInfo'] = routeForm.properties['sx:ciRegNumerInfoBack'];
                                    goingBackForm.properties['sx:ciModelCar'] = routeForm.properties['sx:ciModelCarBack'];
                                }
                                delete goingBackForm.properties['assoc:sx:pbtColleague_added'];
                                if (goingBackForm.properties['sx:pbtMethodTransportation'] === transportationMethods.autoColleagues) {
                                    if (!goingBackForm.associations?.colleague?.includes(routeForm.properties['assoc:sx:pbtColleagueBack_added'])) {
                                        goingBackForm.properties['assoc:sx:pbtColleague_added'] = routeForm.properties['assoc:sx:pbtColleagueBack_added'];
                                        if (goingBackForm.associations?.colleague?.length > 0) {
                                            goingBackForm.properties['assoc:sx:pbtColleague_removed'] = goingBackForm.associations.colleague.join(',');
                                        }
                                    }
                                }
                                else {
                                    if (goingBackForm.associations?.colleague?.length > 0) {
                                        goingBackForm.properties['assoc:sx:pbtColleague_removed'] = goingBackForm.associations.colleague.join(',');
                                    }
                                }

                                const travelForm = routeForm.properties['travelForm'][0];
                                if (navigationIndex === 1) {
                                    travelForm.properties['sx:tfDepartureDate'] = data.properties['sx:btDateStart'];
                                    travelForm.properties['sx:tfArrivalDate'] = data.properties['sx:btDateEnd'];
                                    travelForm.properties['wasUpdated'] = true;
                                    routeDatesCopied = true;
                                }

                                const backTravelForm = goingBackForm.properties['travelForm'][0];
                                backTravelForm.properties['sx:tfPoint'] = travelForm.properties['sx:tfPointArrival'];
                                backTravelForm.properties['sx:tfPointArrival'] = data.properties['sx:btMainPlace'] ? data.properties['sx:btCityReturn'] : data.properties['sx:btReasonWorkPlace'];
                                backTravelForm.properties['sx:tfDepartureDate'] = routeForm.properties['dateStartBack'];
                                backTravelForm.properties['sx:tfArrivalDate'] = data.properties['sx:btDateEnd'];
                                backTravelForm.properties['sx:tfPreferredDepartureTime'] = routeForm.properties['backTravelPreferences'];
                                backTravelForm.properties['wasUpdated'] = true;

                                goingBackForm.properties['wasUpdated'] = true;


                            }
                        }
                    }

                    // Дати маршруту щойно переписані тільки в даних для збереження, а дати проживання
                    // рахуються від них лише при зміні полів на екрані — тож без цього в Alfresco
                    // пішли б старі (або порожні) «Заселення»/«Виселення». Той самий розрахунок, що й
                    // для екрана: documentData — стан до переписування. Має йти до того, як форма
                    // повернення змішається з маршрутами нижче
                    if (routeDatesCopied) {
                        applyTripDateLimits(data, documentData);
                    }

                    const goingBackForm = data.properties['goingBackForm'];
                    if (goingBackForm?.length > 0) {
                        data.properties['routeForm'].push(...goingBackForm);
                    }

                    const updateAssociations = (form) => {
                        if (form.properties['sx:pbtMethodTransportation'] !== transportationMethods.ownCar && form.properties['sx:pbtMethodTransportation'] !== transportationMethods.carRental) {
                            if (form.associations?.businessTripAdditionalFiles && form.associations.businessTripAdditionalFiles.length > 0) {
                                form.properties['assoc:sx:businessTripAdditionalFiles_removed'] = form.associations.businessTripAdditionalFiles.join(',');
                            }
                        }
                        else {
                            const carInfoForm = form.properties['carInfoForm'];
                            if (carInfoForm?.length > 0) {
                                const forRemove = [];
                                if (form.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar) {
                                    if (carInfoForm[0].properties['ownCarAttachments']?.length > 0) {
                                        const attachedFiles = carInfoForm[0].properties['ownCarAttachments'].filter(a => !a.nodeRef && a.type === attachmentTypes.file).map(a => a.value);
                                        form.properties['OwnCarAttachments'] = attachedFiles;
                                        if (form.associations?.businessTripAdditionalFiles?.length > 0) {
                                            forRemove.push(...form.associations.businessTripAdditionalFiles.filter(item => !carInfoForm[0].properties['ownCarAttachments'] || !carInfoForm[0].properties['ownCarAttachments'].some(a => a.nodeRef === item)));
                                        }
                                    }
                                }
                                if (form.properties['sx:pbtMethodTransportation'] === transportationMethods.carRental) {
                                    if (carInfoForm[0].properties['rentalCarBillAttachments']?.length > 0) {
                                        const attachedFiles = carInfoForm[0].properties['rentalCarBillAttachments'].filter(a => !a.nodeRef && a.type === attachmentTypes.file).map(a => a.value);
                                        form.properties['RentalCarBillAttachments'] = attachedFiles;
                                    }
                                    if (carInfoForm[0].properties['rentalCarActAttachments']?.length > 0) {
                                        const attachedFiles = carInfoForm[0].properties['rentalCarActAttachments'].filter(a => !a.nodeRef && a.type === attachmentTypes.file).map(a => a.value);
                                        form.properties['RentalCarActAttachments'] = attachedFiles;
                                    }
                                    if (form.associations?.businessTripAdditionalFiles?.length > 0) {
                                        forRemove.push(...form.associations.businessTripAdditionalFiles.filter(item => (!carInfoForm[0].properties['rentalCarBillAttachments'] || !carInfoForm[0].properties['rentalCarBillAttachments'].some(a => a.nodeRef === item)) && (!carInfoForm[0].properties['rentalCarActAttachments'] || !carInfoForm[0].properties['rentalCarActAttachments'].some(a => a.nodeRef === item))));
                                    }
                                }
                                form.properties['assoc:sx:businessTripAdditionalFiles_removed'] = forRemove.join(',');
                                delete carInfoForm[0].properties['ownCarAttachments'];
                                delete carInfoForm[0].properties['rentalCarBillAttachments'];
                                delete carInfoForm[0].properties['rentalCarActAttachments'];
                            }
                        }
                        if (form.properties['sx:pbtMethodTransportation'] !== transportationMethods.ownCar && form.properties['sx:pbtMethodTransportation'] !== transportationMethods.carRental) {
                            delete form.properties['carInfoForm'];
                            if (form.associations?.carInfo && form.associations.carInfo.length > 0) {
                                form.properties['assoc:sx:pbtCarInfo_removed'] = form.associations.carInfo.join(',');
                            }
                        }
                        else {
                            const carInfoForm = form.properties['carInfoForm'];
                            if (carInfoForm?.length > 0) {
                                carInfoForm[0].properties['sx:ciFuelType'] = carInfoForm[0].properties[`sx:ciFuelType_${carInfoForm[0].properties['sx:ciEngineType']}`];
                            }
                        }
                        if (form.properties['sx:pbtMethodTransportation'] !== transportationMethods.corporateCar) {
                            delete form.properties['sx:ciBrandCar'];
                            delete form.properties['sx:ciRegNumerInfo'];
                            delete form.properties['sx:ciModelCar'];
                        }
                        if (!form.properties['sx:btAccommodationRequired']) {
                            delete form.properties['residenceStatusForm'];
                            if (form.associations?.residenceStatus && form.associations.residenceStatus.length > 0) {
                                form.properties['assoc:sx:pbtResidenceStatus_removed'] = form.associations.residenceStatus.join(',');
                            }
                        }
                        if (form.properties['sx:pbtMethodTransportation'] !== transportationMethods.autoColleagues) {
                            delete form.properties['sx:pbtColleague'];
                            delete form.properties['assoc:sx:pbtColleague_added'];
                            if (form.associations?.colleague?.length > 0) {
                                form.properties['assoc:sx:pbtColleague_removed'] = form.associations.colleague.join(',');;
                            }
                        }
                        else if (form.properties['assoc:sx:pbtColleague_added']) {
                            if (form.properties['sys:node-uuid']) {
                                delete form.properties['sx:pbtColleague'];
                                if (form.associations?.colleague?.length > 0) {
                                    const colleague = form.associations.colleague[0];
                                    if (colleague === form.properties['assoc:sx:pbtColleague_added']) {
                                        delete form.properties['assoc:sx:pbtColleague_added'];
                                    }
                                    else {
                                        form.properties['assoc:sx:pbtColleague_removed'] = colleague;
                                    }
                                }
                            }
                            else {
                                delete form.properties['assoc:sx:pbtColleague_added'];
                            }
                        }
                    }

                    data.properties['routeForm'].forEach((form, index) => {
                        delete form.properties['carAttachments'];
                        if (data.properties['sx:btBusinessTripDestination'] === tripDestinations.ukraine && data.properties['sx:btMultipleRoutes'] && data.properties['sx:btSameTransportForRoutes']) {
                            if (data.properties['methodTransportationForAll'] === transportationMethods.corporateCar) {
                                form.properties['sx:ciBrandCar'] = data.properties['sx:ciBrandCar_forAll'];
                                form.properties['sx:ciModelCar'] = data.properties['sx:ciModelCar_forAll'];
                                form.properties['sx:ciRegNumerInfo'] = data.properties['sx:ciRegNumerInfo_forAll'];
                                form.properties['wasUpdated'] = true;
                            }
                            if (data.properties['methodTransportationForAll'] === transportationMethods.autoColleagues) {
                                form.properties['assoc:sx:pbtColleague_added'] = data.properties['assoc:sx:pbtColleague_added_forAll'];
                                form.properties['wasUpdated'] = true;
                            }
                            if (data.properties['methodTransportationForAll'] === transportationMethods.ownCar || data.properties['methodTransportationForAll'] === transportationMethods.carRental) {
                                if (!form.properties['carInfoForm']) {
                                    form.properties['carInfoForm'] = [{ type: 'sx:CarInfo', properties: {} }];
                                }
                                const forAllForm = data.properties['carInfoForm_forAll'][0];
                                const carInfoForm = form.properties['carInfoForm'][0];
                                carInfoForm.properties['sx:ciBrandCar'] = forAllForm.properties['sx:ciBrandCar'];
                                carInfoForm.properties['sx:ciRegNumerInfo'] = forAllForm.properties['sx:ciRegNumerInfo'];
                                carInfoForm.properties['sx:ciReleaseYear'] = forAllForm.properties['sx:ciReleaseYear'];
                                carInfoForm.properties['sx:ciEngineType'] = forAllForm.properties['sx:ciEngineType'];
                                carInfoForm.properties['sx:ciEngineDisplacement'] = forAllForm.properties['sx:ciEngineDisplacement'];
                                carInfoForm.properties['sx:ciCarColor'] = forAllForm.properties['sx:ciCarColor'];
                                if (forAllForm.properties['sx:ciEngineType']) {
                                    carInfoForm.properties[`sx:ciFuelType_${forAllForm.properties['sx:ciEngineType']}`] = forAllForm.properties[`sx:ciFuelType_${forAllForm.properties['sx:ciEngineType']}`];
                                }
                                carInfoForm.properties['wasUpdated'] = true;
                                if (forAllForm.properties['carInfoUpdate'] && index === 0) {
                                    carInfoForm.properties['carInfoUpdate'] = true;
                                }
                                delete carInfoForm.properties['ownCarAttachments'];
                                delete carInfoForm.properties['rentalCarBillAttachments'];
                                delete carInfoForm.properties['rentalCarActAttachments'];
                                if (index === 0) {
                                    carInfoForm.properties['ownCarAttachments'] = forAllForm.properties['ownCarAttachments'];
                                    carInfoForm.properties['rentalCarBillAttachments'] = forAllForm.properties['rentalCarBillAttachments'];
                                    carInfoForm.properties['rentalCarActAttachments'] = forAllForm.properties['rentalCarActAttachments'];
                                }
                            }
                        }
                        if (data.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad && data.properties['sx:btRouteType'] === routeCreatingTypes.auto) {
                            delete form.properties['transitForm'];
                            if (form.associations?.transitTripPlace && form.associations.transitTripPlace.length > 0) {
                                form.properties['assoc:sx:bptTransitTripPlaceAssoc_removed'] = form.associations.transitTripPlace.join(',');
                            }
                        }
                        else {
                            // транзитні зупинки лежать у маршруті, а не в документі
                            form.properties['transitForm']?.forEach(transitForm => updateAssociations(transitForm));
                        }
                        updateAssociations(form);

                        form.properties['sx:pbtPlace'] = data.properties['sx:btBusinessTripDestination'];

                        if (form.properties['sx:pbtTripGoal']) {
                            form.properties['sx:pbtTripGoalFullUkr'] = `full_${form.properties['sx:pbtTripGoal']}`;
                        }
                        if (form.properties['carInfoForm']?.length > 0 && data.properties['sx:btBusinessTripDestination'] !== tripDestinations.abroad) {
                            delete form.properties['carInfoForm'][0].properties['sx:ciGreenCard'];
                        }
                        if (index === 0) {
                            if (data.properties['sx:btMainPlace']) {
                                if (data.properties['sx:btCityReturn']) {
                                    if (form.properties['sx:btComingFrom'] !== data.properties['sx:btCityReturn']) {
                                        form.properties['sx:btComingFrom'] = data.properties['sx:btCityReturn'];
                                        form.properties['wasUpdated'] = true;
                                    }
                                }
                            }
                            else {
                                if (form.properties['sx:btComingFrom'] !== data.properties['sx:btReasonWorkPlace']) {
                                    form.properties['wasUpdated'] = true;
                                }
                                form.properties['sx:btComingFrom'] = data.properties['sx:btReasonWorkPlace'];
                            }
                        }
                        else {
                            if (data.properties['sx:btBusinessTripDestination'] === tripDestinations.ukraine) {
                                if (form.properties['sx:btComingFrom'] !== data.properties['routeForm'][index - 1].properties['sx:pbtLocality']) {
                                    form.properties['wasUpdated'] = true;
                                }
                                form.properties['sx:btComingFrom'] = data.properties['routeForm'][index - 1].properties['sx:pbtLocality'];
                            }
                            else {
                                if (form.properties['sx:btComingFrom'] !== data.properties['routeForm'][index - 1].properties['sx:pbtCity']) {
                                    form.properties['wasUpdated'] = true;
                                }
                                form.properties['sx:btComingFrom'] = data.properties['routeForm'][index - 1].properties['sx:pbtCity'];
                            }
                        }
                        delete form.properties['carInfoBackForm'];
                        if (data.properties['sx:btBusinessTripDestination'] === tripDestinations.ukraine && data.properties['sx:btMultipleRoutes']) {
                            try {
                                if (index < data.properties['routeForm'].length - 1) {
                                    const travelForm = form.properties['travelForm'][0];
                                    const nextTravelForm = data.properties['routeForm'][index + 1].properties['travelForm'][0];
                                    if (nextTravelForm.properties['sx:tfDepartureDate'] && nextTravelForm.properties['sx:tfDepartureDate'] !== travelForm.properties['sx:tfArrivalDate']) {
                                        travelForm.properties['sx:tfArrivalDate'] = nextTravelForm.properties['sx:tfDepartureDate'];
                                        travelForm.properties['wasUpdated'] = true;
                                        form.properties['wasUpdated'] = true;
                                    }
                                }
                                else {
                                    // going back form
                                    const travelForm = form.properties['travelForm'][0];
                                    if (travelForm.properties['sx:tfArrivalDate'] !== data.properties['sx:btDateEnd']) {
                                        travelForm.properties['sx:tfArrivalDate'] = data.properties['sx:btDateEnd']
                                        travelForm.properties['wasUpdated'] = true;
                                        form.properties['wasUpdated'] = true;
                                    }
                                    const city = data.properties['sx:btMainPlace'] ? data.properties['sx:btCityReturn'] : data.properties['sx:btReasonWorkPlace'];
                                    if (form.properties['sx:pbtLocality'] !== city) {
                                        form.properties['sx:pbtLocality'] = city
                                        form.properties['wasUpdated'] = true;
                                    }
                                    const prevTravelForm = data.properties['routeForm'][index - 1].properties['travelForm'][0];
                                    if (travelForm.properties['sx:tfPoint'] !== prevTravelForm.properties['sx:tfPointArrival']) {
                                        travelForm.properties['sx:tfPoint'] = prevTravelForm.properties['sx:tfPointArrival'];
                                        travelForm.properties['wasUpdated'] = true;
                                        form.properties['wasUpdated'] = true;
                                    }
                                }
                            }
                            catch (err) {
                                console.error('Configue props error');
                                console.error(err);
                            }
                        }
                        if (form.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar) {
                            const travelForm = form.properties['travelForm'][0];
                            if (travelForm.properties['sx:tfPreferredDepartureTime']) {
                                travelForm.properties['sx:tfPreferredDepartureTime'] = '';
                                travelForm.properties['wasUpdated'] = true;
                                form.properties['wasUpdated'] = true;
                            }
                        }
                        if (form.properties['residenceStatusForm']?.length > 0) {
                            const residenceStatusForm = form.properties['residenceStatusForm'][0];
                            const startDate = residenceStatusForm.properties['sx:rsArrivalDate'] ? new Date(residenceStatusForm.properties['sx:rsArrivalDate']) : null;
                            const endDate = residenceStatusForm.properties['sx:rsDepartureDate'] ? new Date(residenceStatusForm.properties['sx:rsDepartureDate']) : null;
                            if (startDate && endDate) {
                                const period = ((endDate - startDate) / (1000 * 60 * 60 * 24) + 1).toFixed() ;
                                if (residenceStatusForm.properties['sx:rsNumberOfDays'] !== period) {
                                    residenceStatusForm.properties['sx:rsNumberOfDays'] = period;
                                    residenceStatusForm.properties['wasUpdated'] = true;
                                    form.properties['wasUpdated'] = true;
                                }
                            }
                        }
                    });
                }
            }
            if (removedRouteForms.length > 0) {
                data.properties['assoc:sx:btPlaceBusinessTrip_removed'] = removedRouteForms.join(',');
            }
            if (formMode === formModes.create) {
                data.properties['sx:btSeconded'] = userContext?.login;
            }
        }
        if (data.type === alfrescoTypes.travelLetterAuto) {
            if (removedOperationForms.length > 0) {
                data.properties['assoc:sx:tlaOperation_removed'] = removedOperationForms.join(',');
            }
            if (data.properties['assoc:sx:tlaDriver_added']) {
                const driver = data.associations?.driver?.length > 0 ? data.associations.driver[0] : null;
                if (driver) {
                    if (driver === data.properties['assoc:sx:tlaDriver_added']) {
                        delete data.properties['assoc:sx:tlaDriver_added'];
                    }
                    else {
                        data.properties['assoc:sx:tlaDriver_removed'] = driver;
                    }
                }
            }
            if (data.properties['operationForm']?.length > 0) {
                data.properties['operationForm'].forEach(form => {
                    form.attachments = form.properties['sx:attachments']?.filter(item => !item.nodeRef).map(item => item.file);
                    delete form.properties['sx:attachments'];
                });
            }
            if (data.properties['travelLetterCarInfo']?.length > 0) {
                const carInfoForm = data.properties['travelLetterCarInfo'][0];
                carInfoForm.properties['sx:ciFuelType'] = carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`];
            }
        }
        if (data.type === alfrescoTypes.advanceReport) {
            delete data.properties['businessTrip'];
            if (data.properties['assoc:sx:arEmployee_added']) {
                const employee = data.associations?.employee?.length > 0 ? data.associations.employee[0] : null;
                if (employee) {
                    if (employee === data.properties['assoc:sx:arEmployee_added']) {
                        delete data.properties['assoc:sx:arEmployee_added'];
                    }
                    else {
                        data.properties['assoc:sx:arEmployee_removed'] = employee;
                    }
                }
            }
            if (removedReportForms.length > 0) {
                data.properties['assoc:sx:arReport_removed'] = removedReportForms.join(',');
            }
            if (removedResultForms.length > 0) {
                data.properties['assoc:sx:businessTripReports_removed'] = removedResultForms.join(',');
            }
            if (data.properties['reportForm']?.length > 0) {
                data.properties['reportForm'].forEach(form => {
                    form.attachments = form.properties['sx:attachments']?.filter(item => !item.nodeRef).map(item => item.file);
                    delete form.properties['sx:attachments'];
                });
            }
            if (data.associations?.businessTripAdditionalFiles?.length > 0) {
                const forRemove = data.associations.businessTripAdditionalFiles.filter(item =>
                    !data.properties['sx:attachments'] || !data.properties['sx:attachments'].some(a => a.nodeRef === item)
                );
                data.properties['assoc:sx:businessTripAdditionalFiles_removed'] = forRemove.join(',');
            }
            delete data.properties['sx:attachments'];
            delete data.properties['businessTripFiles'];
        }
        if (data.type === alfrescoTypes.transfer) {
            if (data.properties['sx:frToOffice'] !== juniorSalesConsultantPosition) {
                delete data.properties['sx:trSchedule'];
            }
        }
        const configueFloatFields = (fields, dataObject) => {
            const floatFields = fields.filter(f => f.type === formFieldTypes.string && f.pattern === formStringFieldPatterns.float);
            floatFields.forEach(f => {
                if (dataObject.properties[f.name]) {
                    dataObject.properties[f.name] = dataObject.properties[f.name].replaceAll(' ', '').replace(',', '.');
                }
            });
            const subformFields = fields.filter(f => f.type === formFieldTypes.subform);
            subformFields.forEach(subformField => {
                const subFormValues = dataObject.properties[subformField.name];
                if (subFormValues?.length > 0) {
                    subFormValues.forEach(val => configueFloatFields(subformField.fields, val));
                }
            });
            const groupFields = fields.filter(f => f.type === formFieldTypes.group);
            groupFields.forEach(group => {
                configueFloatFields(group.fields, dataObject);
            });
        }
        configueFloatFields(data.form.fields, data);

        delete data.properties['cm:content'];
        delete data.properties['sx:attachments'];

        return data;
    }

    const onAction = (key) => {
        if (!saving) {
            switch (key) {
                case actionTypes.save:
                    const checkResult = checkInputPage();
                    if (checkResult.success) {
                        submit();
                    }
                    else {
                        setSubmitted(true);
                        if (documentData.type === alfrescoTypes.businessTrip && checkResult.nIndex === 2) {
                            messageDialog(i18next.t('error'), i18next.t('notAllFileAdded'));
                        }
                    }
                    break;
                case actionTypes.close:
                    navigate(urls.documentsPage);
                    break;
                case actionTypes.signAdditionalContent:
                case actionTypes.sign:
                    if (documentData.type === alfrescoTypes.travelLetterAuto && (documentData.properties['sx:dfState'] === documentStatuses.processingTravelLetterAuto || documentData.properties['sx:dfState'] === documentStatuses.refinementSeconded)) {
                        if (!checkInputPage().success) {
                            messageDialog(i18next.t('error'), i18next.t('document.signCheckError'));
                            return;
                        }
                    }

                    if (documentData.properties['sx:dfState'] === documentStatuses.formationsigningOrder) {
                        if (attachments?.length <= 0 && !attachmentAdded) {
                            messageDialog(i18next.t('error'), i18next.t('document.attachmentsNotAdded'));
                            return;
                        }
                    }
                    if (documentData.type === alfrescoTypes.businessTrip) {
                        const checkResult = checkInputPage();
                        if (!checkResult.success) {
                            if (checkResult.nIndex === 2) {
                                messageDialog(i18next.t('error'), i18next.t('notAllFileAdded'));
                            }
                            else {
                                messageDialog(i18next.t('error'), i18next.t('document.signCheckError'));
                            }
                            return;
                        }
                    }
                    setSigning(true);
                    showModalDialog('modalDialog', i18next.t('document.signFormTitle'), '', <SignDocumentForm docId={id} taskId={taskId} onError={() => hideModalDialog('modalDialog')} />, 'feedPopup');
                    break;
                case actionTypes.delete:
                    let message = i18next.t('document.deleteVacationMessage');
                    if (documentData?.type === alfrescoTypes.certification) message = i18next.t('document.deleteCertificationMessage');
                    if (documentData?.type === alfrescoTypes.businessTrip) message = i18next.t('document.deleteBusinessTripMessage');

                    yesNoDialog(i18next.t('attentionTitle'), message, async () => {
                        setLoading(true);
                        const response = await fetch(`/api/Document/Delete?id=${id}`, { method: 'DELETE', headers: { 'Content-Type': 'application/json' } });
                        if (response.ok) {
                            navigate(urls.mainPage);
                        }
                        else {
                            setLoading(false);
                            unknownErrorMessageDialog();
                        }
                    });
                    break;
                case actionTypes.cancel:
                    const onReject = (comment) => {
                        if (!loading) {
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.cancel, comment.content, (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(urls.tasksPage);
                                }
                            });
                        }
                    }
                    showModalDialog('modalDialog', i18next.t('document.regectFormTitle'), "", <CommentForm handleChangeComment={onReject} submitBtnText={i18next.t('document.reject')} cancelBtnText={i18next.t('document.cancel')} />, "feedPopup");
                    break;
                case actionTypes.refinement:
                    const onRefinement = (comment) => {
                        if (!loading) {
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.refinement, comment.content, (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(urls.tasksPage);
                                }
                            });
                        }
                    }
                    showModalDialog('modalDialog', i18next.t('document.refinementFormTitle'), "", <CommentForm handleChangeComment={onRefinement} submitBtnText={i18next.t('document.refinement')} cancelBtnText={i18next.t('document.cancel')} />, "feedPopup");
                    break;
                case actionTypes.resign:
                    const onSend = (comment) => {
                        if (!loading) {
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.resign, comment.content, (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(0);
                                }
                            });
                        }
                    }
                    showModalDialog('modalDialog', i18next.t('document.resignFormTitle'), "", <CommentForm handleChangeComment={onSend} submitBtnText={i18next.t('document.send')} cancelBtnText={i18next.t('document.cancel')} />, "feedPopup");
                    break;
                case actionTypes.reviewed: {
                    const dialogTitle = i18next.t('document.taskReviewed');
                    const dialogMessage = i18next.t('document.reviewedTaskMessage');

                    yesNoDialog(dialogTitle, dialogMessage, () => {
                        if (!loading) {
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.reviewed, '', (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(urls.mainPage);
                                }
                            });
                        }
                    });
                    break;
                }
                case actionTypes.approve: {
                    if ((documentData.type === alfrescoTypes.advanceReport && (documentData.properties['sx:dfState'] === documentStatuses.formationReport || documentData.properties['sx:dfState'] === documentStatuses.refinementAdvanceReport))
                        || (documentData.type === alfrescoTypes.travelLetterAuto && documentData.properties['sx:dfState'] === documentStatuses.refinementSeconded)) {
                        if (!checkInputPage().success) {
                            messageDialog(i18next.t('error'), i18next.t('document.approveCheckError'));
                            return;
                        }
                    }

                    const dialogTitle = i18next.t('document.taskApproving');
                    const dialogMessage = i18next.t('document.approveTaskMessage');

                    yesNoDialog(dialogTitle, dialogMessage, () => {
                        if (!loading) {
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.approve, '', (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(urls.mainPage);
                                }
                            });
                        }
                    });
                    break;
                }
                case actionTypes.accept: {
                    let dialogTitle = i18next.t('document.taskAcception');
                    let dialogMessage = i18next.t('document.acceptTaskMessage');
                    if (documentData.properties['sx:dfState'] === documentStatuses.enteringInfo) {
                        dialogTitle = i18next.t('document.sendAcception');
                        dialogMessage = i18next.t('document.acceptSendMessage');
                    }
                    yesNoDialog(dialogTitle, dialogMessage, () => {
                        if (!loading) {
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.accept, '', (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(0);
                                }
                            });
                        }
                    });
                    break;
                }
                case actionTypes.edit:
                    setFormMode(formModes.edit);
                    if (navigationIndex === 3) {
                        setNavigationIndex(0);
                    }
                    break;
                case actionTypes.cancelEdit:
                    navigate(0);
                    break;
                case actionTypes.send:
                    if (checkInputPage().success) {
                        yesNoDialog(i18next.t('document.sendAcception'), i18next.t('document.acceptSendMessage'), () => {
                            setLoading(true);
                            sendDocument(id, (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(urls.documentsPage);
                                }
                            });
                        });
                    }
                    else {
                        messageDialog(i18next.t('error'), i18next.t('document.sendError'));
                    }
                    break;
            }
        }
    }

    const initDocumentData = (responseData) => {
        let initData = null;
        setMainContent(null);

        const isTask = location.pathname.startsWith(urls.tasksPage + '/');

        if (location.pathname === urls.newVacationPage) {
            initData = {
                title: i18next.t('document.newVacationTitle'),
                form: responseData,
                type: alfrescoTypes.vacationClaim,
                properties: {}
            }
            initSelectFieldsValues(responseData.fields, initData.properties);
            const endDateField = responseData.fields.find(f => f.name === 'sx:claimDateEnd');
            if (endDateField) {
                endDateField.disabled = true;
            }
            initData.properties["sx:dfDocKind"] = vacationKinds.main;
            initData.properties['sx:dfState'] = documentStatuses.template;
            initData.properties['sx:dfState_label'] = i18next.t('document.newVacationStatusLabel');
        }
        else if (location.pathname === urls.newCertificationPage) {
            initData = {
                title: i18next.t('document.newCertificationTitle'),
                form: responseData,
                type: alfrescoTypes.certification,
                properties: {}
            }
            initSelectFieldsValues(responseData.fields, initData.properties);
            initData.properties['sx:dfState'] = documentStatuses.template;
            initData.properties['sx:dfState_label'] = i18next.t('document.newCertificationStatusLabel');
            const docKindField = initData.form.fields.find(f => f.name === 'sx:dfDocKind');
            if (docKindField) {
                const otherValue = docKindField.values.data.find(item => item.value === 'Other');
                if (otherValue) {
                    docKindField.values.data = docKindField.values.data.filter(item => item.value !== 'Other');
                    docKindField.values.data.push(otherValue);
                }
            }
        }
        else if (location.pathname === urls.newBusinessTripPage) {
            if (!userContext?.canCreateBusinessTrip) {
                navigate(urls.mainPage);
                return;
            }
            initData = {
                title: i18next.t('document.newBusinessTripTitle'),
                form: responseData,
                type: alfrescoTypes.businessTrip,
                properties: {
                    'sx:btMainPlace': true
                }
            }
            initSelectFieldsValues(responseData.fields, initData.properties);
            initData.properties['sx:dfState'] = documentStatuses.template;
            initData.properties['sx:dfState_label'] = i18next.t('document.newBusinessTripStatusLabel');
            initData.properties['assoc:sx:btSeconded_added'] = userContext?.nodeRef;
            initData.properties['sx:btChild3Years'] = userContext?.childUnder3Years;
            initData.properties['sx:btMilitaryDuty'] = userContext?.conscript;
            initData.properties['carInfoForm_forAll'] = [{ type: 'sx:CarInfo', properties: {} }];
            initData.properties['routeForm'] = [{
                type: 'sx:PlaceBusinessTrip',
                properties: {
                    'residenceStatusForm': [{ type: 'sx:ResidenceStatus', properties: {} }],
                    'travelForm': [{ type: 'sx:TravelForm', properties: {} }],
                    'carInfoForm': [{ type: 'sx:CarInfo', properties: {} }],
                    'carInfoBackForm': [{ type: 'sx:CarInfo', properties: {} }],
                    'sx:pbtSameTransportBack': true,
                    'sx:btAccommodationRequired': true
                }
            }];
            initData.properties['goingBackForm'] = [{
                type: 'sx:PlaceBusinessTrip',
                properties: {
                    'residenceStatusForm': [{ type: 'sx:ResidenceStatus', properties: {} }],
                    'travelForm': [{ type: 'sx:TravelForm', properties: {} }],
                    'carInfoForm': [{ type: 'sx:CarInfo', properties: {} }],
                    'carInfoBackForm': [{ type: 'sx:CarInfo', properties: {} }],
                    'sx:btAccommodationRequired': false,
                    'sx:pbtReturnHome': true
                }
            }];
        }
        else if (location.pathname === urls.newDetailsPage) {
            initData = {
                title: i18next.t('document.newDetailsTitle'),
                form: responseData,
                type: alfrescoTypes.details,
                properties: {}
            }
            initSelectFieldsValues(responseData.fields, initData.properties);
            initData.properties['sx:dfState'] = documentStatuses.template;
            initData.properties['sx:dfState_label'] = i18next.t('document.newDetailsStatusLabel');
        }
        else if (location.pathname === urls.newTransferRequestPage) {
            if (transferRequestPositions.includes(userContext.position)) {
                initData = {
                    title: i18next.t('document.newTransferRequestTitle'),
                    form: responseData,
                    type: alfrescoTypes.transferRequest,
                    properties: {}
                }
                initSelectFieldsValues(responseData.fields, initData.properties);
                initData.properties['sx:dfState'] = documentStatuses.template;
                initData.properties['sx:dfState_label'] = i18next.t('document.newTransferRequestStatusLabel');
            }
            else {
                messageDialog(i18next.t('error'), i18next.t('document.transferRequest.createPageError'), () => { navigate(urls.mainPage) });
                return;
            }
        }
        else {
            initData = responseData;
            initData.form = JSON.parse(initData.form);


            const creatorField = initData.form.fields.find(f => f.name === 'cm:creator');
            if (creatorField && initData.properties['cm:creator']) {
                creatorField.userLogin = initData.properties['cm:creator'];
                if (responseData.creatorInfo?.avatarNodeRef) {
                    creatorField.avatarId = responseData.creatorInfo.avatarNodeRef.split('/').pop();
                }
            }

            initData.properties['cm:creator'] = initData.creatorInfo.creatorFullName;
            if (initData.associations?.subordinate?.length > 0) {
                initData.properties['assoc:sx:ctSubordinate_added'] = initData.associations.subordinate[0];
                if (initData.creatorInfo.creatorNodeRef !== userContext?.nodeRef) {
                    const subordinateField = initData.form.fields.find(f => f.name === 'assoc:sx:ctSubordinate_added');
                    subordinateField.subordinatesOnly = false;
                }
            }
            setAttachmentAdded(initData.associations?.additionalDocuments?.length > 0);
            if (initData.type === alfrescoTypes.vacationClaim) {
                initData.properties['sx:attachments'] = initData.associations?.additionalDocuments?.map(item => { return { nodeRef: item } }) ?? [];
                const attachmentsField = initData.form.fields.find(f => f.name === 'sx:attachments');
                attachmentsField.docId = initData.properties['sys:node-uuid'];
            }
            if (initData.type === alfrescoTypes.businessTrip) {
                initData.properties['attachments'] = [];
                initData.properties['passportAttachments'] = [];
                if (initData.properties['links']) {
                    initData.properties['attachments'].push(...initData.properties['links'].map(link => {
                        return {
                            type: attachmentTypes.link,
                            nodeRef: link.nodeRef,
                            value: link.properties['sx:linkText']
                        }
                    }));
                }
                if (initData.properties['businessTripFiles']) {
                    initData.properties['attachments'].push(...initData.properties['businessTripFiles']
                        .filter(file => file.properties['sx:btAdditionalDocumentKind'] === businessTripAttachmentFileTypes.other)
                        .map(file => {
                            return {
                                type: attachmentTypes.file,
                                nodeRef: file.nodeRef,
                                value: {
                                    fileName: file.properties['cm:title'],
                                    mimeType: file.mimetype,
                                }
                            }
                        }));
                    initData.properties['passportAttachments'].push(...initData.properties['businessTripFiles']
                        .filter(file => file.properties['sx:btAdditionalDocumentKind'] === businessTripAttachmentFileTypes.foreignPassport)
                        .map(file => {
                            return {
                                type: attachmentTypes.file,
                                nodeRef: file.nodeRef,
                                value: {
                                    fileName: file.properties['cm:title'],
                                    mimeType: file.mimetype,
                                }
                            }
                        }));
                }

                initData.properties['carInfoForm_forAll'] = [{ type: 'sx:CarInfo', properties: {} }];
                if (initData.properties['sx:btDateStart']) {
                    const destinationField = initData.form.fields.find(f => f.name === 'sx:btBusinessTripDestination');
                    destinationField.disabled = true;
                }

                if (initData.properties['routeForm'] && initData.properties['routeForm'].length > 0) {
                    initData.properties['routeForm'].forEach(form => {
                        if (form.properties['transitForm']?.length > 0) {
                            form.properties['transitForm'].forEach(transit => {
                                if (transit.properties['travelForm']?.length > 0) {
                                    transit.properties['transitDate'] = transit.properties['travelForm'][0].properties['sx:tfDepartureDate'];
                                }
                                // транзитна зупинка — такий самий пункт маршруту, тому вкладені
                                // форми їй потрібні так само, як і маршруту
                                initRouteSubForms(transit);
                            });
                        }

                        initRouteSubForms(form);

                        if (form.properties['residenceStatusForm'] && form.properties['residenceStatusForm'].length > 0) {
                            const residenceStatusForm = form.properties['residenceStatusForm'][0];
                            const startDate = residenceStatusForm.properties['sx:rsArrivalDate'] ? new Date(residenceStatusForm.properties['sx:rsArrivalDate']) : null;
                            const endDate = residenceStatusForm.properties['sx:rsDepartureDate'] ? new Date(residenceStatusForm.properties['sx:rsDepartureDate']) : null;
                            if (startDate && endDate) {
                                const period = ((endDate - startDate) / (1000 * 60 * 60 * 24) + 1).toFixed();
                                residenceStatusForm.properties['stayPeriod'] = i18next.t('form.fields.stayPeriodText').replace('{count}', period).replace('{days}', getWordWithCorrectEnding(period, 'день'));
                                residenceStatusForm.properties['sx:rsNumberOfDays'] = period;
                            }
                        }
                        const initCarAttachments = (form) => {
                            if (form.properties['carAttachments']?.length > 0) {
                                const carInfoForm = form.properties['carInfoForm'][0];
                                carInfoForm.properties['ownCarAttachments'].push(...form.properties['carAttachments']
                                    .filter(file => file.properties['sx:btAdditionalDocumentKind'] === businessTripAttachmentFileTypes.vehicleCertificate)
                                    .map(file => {
                                        return {
                                            type: attachmentTypes.file,
                                            nodeRef: file.nodeRef,
                                            value: {
                                                fileName: file.properties['cm:title'],
                                                mimeType: file.mimetype,
                                            }
                                        }
                                    }));
                                carInfoForm.properties['rentalCarBillAttachments'].push(...form.properties['carAttachments']
                                    .filter(file => file.properties['sx:btAdditionalDocumentKind'] === businessTripAttachmentFileTypes.carRentalInvoice)
                                    .map(file => {
                                        return {
                                            type: attachmentTypes.file,
                                            nodeRef: file.nodeRef,
                                            value: {
                                                fileName: file.properties['cm:title'],
                                                mimeType: file.mimetype,
                                            }
                                        }
                                    }));
                                carInfoForm.properties['rentalCarActAttachments'].push(...form.properties['carAttachments']
                                    .filter(file => file.properties['sx:btAdditionalDocumentKind'] === businessTripAttachmentFileTypes.carRentalAgreement)
                                    .map(file => {
                                        return {
                                            type: attachmentTypes.file,
                                            nodeRef: file.nodeRef,
                                            value: {
                                                fileName: file.properties['cm:title'],
                                                mimeType: file.mimetype,
                                            }
                                        }
                                    }));
                            }
                        }
                        initCarAttachments(form);
                        if (form.properties['transitForm']?.length > 0) {
                            form.properties['transitForm'].forEach(transit => {
                                initCarAttachments(transit);
                            });
                        }
                    });
                    initData.properties['goingBackForm'] = initData.properties['routeForm'].filter(f => f.properties['sx:pbtReturnHome']);
                    initData.properties['routeForm'] = initData.properties['routeForm'].filter(f => !f.properties['sx:pbtReturnHome']);
                }
                else {
                    initData.properties['routeForm'] = [{
                        type: 'sx:PlaceBusinessTrip',
                        properties: {
                            'residenceStatusForm': [{ type: 'sx:ResidenceStatus', properties: {} }],
                            'travelForm': [{ type: 'sx:TravelForm', properties: {} }],
                            'carInfoForm': [{ type: 'sx:CarInfo', properties: {} }],
                            'carInfoBackForm': [{ type: 'sx:CarInfo', properties: {} }],
                            'sx:pbtSameTransportBack': true,
                            'sx:btAccommodationRequired': true
                        }
                    }];
                    initData.properties['goingBackForm'] = [{
                        type: 'sx:PlaceBusinessTrip',
                        properties: {
                            'residenceStatusForm': [{ type: 'sx:ResidenceStatus', properties: {} }],
                            'travelForm': [{ type: 'sx:TravelForm', properties: {} }],
                            'carInfoForm': [{ type: 'sx:CarInfo', properties: {} }],
                            'carInfoBackForm': [{ type: 'sx:CarInfo', properties: {} }],
                            'sx:btAccommodationRequired': false,
                            'sx:pbtReturnHome': true
                        }
                    }];
                }
                if (initData.properties['sx:dfState'] === documentStatuses.processing && isTask) {
                    initData.properties['sx:btDateStartMain'] = initData.properties['sx:btDateStart'];
                    initData.properties['sx:btDateEndMain'] = initData.properties['sx:btDateEnd'];
                    initData.properties['routeFormMain'] = initData.properties['routeForm'];
                }
                if ((initData.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad || !initData.properties['sx:btMultipleRoutes']) && initData.properties['goingBackForm']?.length > 0) {
                    const routeForm = initData.properties['routeForm'][0];
                    const goingBackForm = initData.properties['goingBackForm'][0];
                    const backTravelForm = goingBackForm.properties['travelForm'][0];

                    routeForm.properties['sx:pbtBackMethodTransportation'] = goingBackForm.properties['sx:pbtMethodTransportation'];
                    routeForm.properties['dateStartBack'] = backTravelForm.properties['sx:tfDepartureDate'];
                    routeForm.properties['backTravelPreferences'] = backTravelForm.properties['sx:tfPreferredDepartureTime'];
                    routeForm.properties['carInfoBackForm'] = goingBackForm.properties['carInfoForm'];
                    routeForm.properties['assoc:sx:pbtColleagueBack_added'] = goingBackForm.properties['assoc:sx:pbtColleague_added'];
                    routeForm.properties['sx:ciBrandCarBack'] = goingBackForm.properties['sx:ciBrandCar'];
                    routeForm.properties['sx:ciModelCarBack'] = goingBackForm.properties['sx:ciModelCar'];
                    routeForm.properties['sx:ciRegNumerInfoBack'] = goingBackForm.properties['sx:ciRegNumerInfo'];
                }
                if (initData.properties['sx:btSameTransportForRoutes']) {
                    const routeForm = initData.properties['routeForm'][0];
                    initData.properties['methodTransportationForAll'] = routeForm.properties['sx:pbtMethodTransportation'];
                    if (initData.properties['methodTransportationForAll'] === transportationMethods.corporateCar) {
                        initData.properties['sx:ciBrandCar_forAll'] = routeForm.properties['sx:ciBrandCar'];
                        initData.properties['sx:ciModelCar_forAll'] = routeForm.properties['sx:ciModelCar'];
                        initData.properties['sx:ciRegNumerInfo_forAll'] = routeForm.properties['sx:ciRegNumerInfo'];
                    }
                    if (initData.properties['methodTransportationForAll'] === transportationMethods.autoColleagues) {
                        initData.properties['assoc:sx:pbtColleague_added_forAll'] = routeForm.properties['assoc:sx:pbtColleague_added'];
                        initData.properties['routeForm'].forEach(form => {
                            if (!(form.properties['assoc:sx:pbtColleague_added']?.length > 0) || form.properties['assoc:sx:pbtColleague_added'][0] !== initData.properties['assoc:sx:pbtColleague_added_forAll']) {
                                form.properties['assoc:sx:pbtColleague_added'] = initData.properties['assoc:sx:pbtColleague_added_forAll'];
                                form.properties['wasUpdated'] = true;
                            }
                        });
                    }
                    if (initData.properties['methodTransportationForAll'] === transportationMethods.ownCar || initData.properties['methodTransportationForAll'] === transportationMethods.carRental) {
                        if (!initData.properties['carInfoForm_forAll']) {
                            initData.properties['carInfoForm_forAll'] = [{ type: 'sx:CarInfo', properties: {} }];
                        }
                        const forAllForm = initData.properties['carInfoForm_forAll'][0];
                        const carInfoForm = routeForm.properties['carInfoForm'][0];
                        forAllForm.properties['sx:ciBrandCar'] = carInfoForm.properties['sx:ciBrandCar'];
                        forAllForm.properties['sx:ciRegNumerInfo'] = carInfoForm.properties['sx:ciRegNumerInfo'];
                        forAllForm.properties['sx:ciReleaseYear'] = carInfoForm.properties['sx:ciReleaseYear'];
                        forAllForm.properties['sx:ciEngineType'] = carInfoForm.properties['sx:ciEngineType'];
                        forAllForm.properties['sx:ciEngineDisplacement'] = carInfoForm.properties['sx:ciEngineDisplacement'];
                        forAllForm.properties['sx:ciCarColor'] = carInfoForm.properties['sx:ciCarColor'];
                        if (carInfoForm.properties['sx:ciEngineType']) {
                            forAllForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`] = carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`];
                        }
                        forAllForm.properties['ownCarAttachments'] = carInfoForm.properties['ownCarAttachments'];
                        forAllForm.properties['rentalCarBillAttachments'] = carInfoForm.properties['rentalCarBillAttachments'];
                        forAllForm.properties['rentalCarActAttachments'] = carInfoForm.properties['rentalCarActAttachments'];
                    }
                }
            }
            if (initData.type === alfrescoTypes.travelLetterAuto) {
                const carInfoField = initData.form.fields.find(f => f.name === 'travelLetterCarInfo');
                if (carInfoField) {
                    carInfoField.fields = carInfoField.fields.filter(f => f.name !== 'sx:ciGreenCard' && f.name !== 'carInfoUpdate');
                }
                if (initData.properties['operationForm']?.length > 0) {
                    initData.properties['operationForm'].forEach(operation => {
                        if (operation.associations?.additionalDocuments?.length > 0) {
                            operation.properties['sx:attachments'] = operation.associations.additionalDocuments.map(item => { return { nodeRef: item } });
                        }
                    });
                }
                if (!initData.properties['operationForm'] || initData.properties['operationForm']?.length <= 0) {
                    initData.properties['operationForm'] = [{
                        type: 'sx:Operation',
                        properties: {}
                    }];
                }
                if (initData.properties['travelLetterCarInfo']?.length > 0) {
                    const carInfoForm = initData.properties['travelLetterCarInfo'];
                    if (carInfoForm[0].properties['sx:ciEngineType']) {
                        carInfoForm[0].properties[`sx:ciFuelType_${carInfoForm[0].properties['sx:ciEngineType']}`] = carInfoForm[0].properties['sx:ciFuelType'];
                    }
                }
                if (initData.associations?.relatedBusinessTrip?.length > 0) {
                    const orderNumberField = initData.form.fields.find(f => f.name === 'sx:tlaOrderNumber');
                    orderNumberField.businessTripNodeRef = initData.associations.relatedBusinessTrip[0];
                }
            }
            if (initData.type === alfrescoTypes.advanceReport) {
                if (initData.properties['reportForm']?.length > 0) {
                    initData.properties['reportForm'].forEach(report => {
                        if (report.associations?.additionalDocuments?.length > 0) {
                            report.properties['sx:attachments'] = report.associations.additionalDocuments.map(item => { return { nodeRef: item } });
                        }
                    });
                }
                if (!initData.properties['resultForm'] || initData.properties['resultForm']?.length <= 0) {
                    if (initData.properties['sx:btrNeedReport']) {
                        initData.properties['resultForm'] = [{
                            type: 'sx:businessTripReport',
                            properties: {}
                        }];
                    }
                    else {
                        initData.properties['resultForm'] = [];
                    }
                }
                let sum = 0.0;
                if (!initData.properties['reportForm']) {
                    initData.properties['reportForm'] = [];
                }
                if (initData.properties['sx:dfState'] === documentStatuses.formationReport && !initData.properties['reportForm'].some(form => !form.properties['sx:autofillObject']) && formMode === formModes.edit) {
                    if (!initData.properties['sx:btrNeedReport']) {
                        initData.properties['reportForm'].push({
                            type: 'sx:Report',
                            properties: {}
                        });
                    }
                }
                else {
                    initData.properties['reportForm'].forEach(form => {
                        const reportSum = form.properties['sx:rpAmountUAH']?.toString();
                        if (reportSum) {
                            const reportSumValue = parseFloat(reportSum.replaceAll(' ', '').replace(',', '.'));
                            if (reportSumValue) {
                                sum += reportSumValue;
                            }
                        }
                    });
                }
                initData.properties['sx:arSum'] = sum.toFixed(2).replace('.', ',');
                initData.properties['attachments'] = [];
                initData.properties['sx:attachments'] = [];
                if (initData.properties['businessTripFiles']) {
                    initData.properties['sx:attachments'].push(...initData.properties['businessTripFiles']
                        .filter(file => file.properties['sx:btAdditionalDocumentKind'] === businessTripAttachmentFileTypes.other)
                        .map(file => {
                            return {
                                type: attachmentTypes.file,
                                nodeRef: file.nodeRef,
                                value: {
                                    fileName: file.properties['cm:title'],
                                    mimeType: file.mimetype,
                                }
                            }
                        }));
                }
            }
            if (initData.type === alfrescoTypes.certification) {
                initData.properties['cm:content'] = initData.associations?.mainContent?.map(item => { return { nodeRef: item } }) ?? [];
                const contentField = initData.form.fields.find(f => f.name === 'cm:content');
                if (contentField) {
                    contentField.docId = initData.properties['sys:node-uuid'];
                }
                const docKindField = initData.form.fields.find(f => f.name === 'sx:dfDocKind');
                if (docKindField) {
                    const otherValue = docKindField.values.data.find(item => item.value === 'Other');
                    if (otherValue) {
                        docKindField.values.data = docKindField.values.data.filter(item => item.value !== 'Other');
                        docKindField.values.data.push(otherValue);
                    }
                }
            }
            if (initData.type === alfrescoTypes.unstructuredDocument) {
                if (initData.properties['sx:dfDocKind'] === unstructuredDocumentKinds.letters) {
                    initData.properties['sx:undSubkindLetters'] = initData.properties['sx:dfDocSubKind'];
                }
                if (initData.properties['sx:dfDocKind'] === unstructuredDocumentKinds.claim) {
                    initData.properties['sx:undSubkindClaim'] = initData.properties['sx:dfDocSubKind'];
                }
                if (initData.properties['sx:dfDocKind'] === unstructuredDocumentKinds.contract) {
                    initData.properties['sx:undSubkindContract'] = initData.properties['sx:dfDocSubKind'];
                }
                if (initData.properties['sx:dfDocKind'] === unstructuredDocumentKinds.order) {
                    initData.properties['sx:undSubkindOrder'] = initData.properties['sx:dfDocSubKind'];
                }
                if (initData.properties['sx:dfDocKind'] === unstructuredDocumentKinds.other) {
                    initData.properties['sx:undSubkindOther'] = initData.properties['sx:dfDocSubKind'];
                }
            }
        }

        if (initData?.taskButtons && initData.taskButtons[taskId]?.length > 0) {
            if (initData.taskButtons[taskId].some(btn => btn.split('|')[0] === actionTypes.sign)) {
                setHasSignBtn(true);
            }
        }

        initSelectFieldsValues(initData.form.fields, initData.properties, true);

        const initFloatFields = (fields, dataObject) => {
            const floatFields = fields.filter(f => f.type === formFieldTypes.string && f.pattern === formStringFieldPatterns.float);
            floatFields.forEach(f => {
                if (dataObject.properties[f.name]) {
                    if (typeof (dataObject.properties[f.name]) === 'number') {
                        dataObject.properties[f.name] = dataObject.properties[f.name].toFixed(2).replace('.', ',');
                    }
                    else {
                        dataObject.properties[f.name] = dataObject.properties[f.name].replace('.', ',');
                    }
                }
            });
            const subformFields = fields.filter(f => f.type === formFieldTypes.subform);
            subformFields.forEach(subformField => {
                const subFormValues = dataObject.properties[subformField.name];
                if (subFormValues?.length > 0) {
                    subFormValues.forEach(val => initFloatFields(subformField.fields, val));
                }
            });
            const groupFields = fields.filter(f => f.type === formFieldTypes.group);
            groupFields.forEach(group => {
                initFloatFields(group.fields, dataObject);
            });
        }
        initFloatFields(initData.form.fields, initData);

        updateFields(initData);
        setDocumentData(initData);
        setSaving(false);
        setLoading(false);

        if (initData.type === alfrescoTypes.businessTrip && isTask && formMode == formModes.read
            && initData.properties['sx:dfState'] === documentStatuses.signingSeconded) {
            setNavigationIndex(2);
        }
    }

    useEffect(() => {
        if (documentData?.form) {
            const updatedData = structuredClone(documentData);
            updateFields(updatedData);
            setDocumentData(updatedData);
        }
    }, [formMode, hasSignBtn, navigationIndex]);

    useEffect(() => {
        if (documentData.type === alfrescoTypes.businessTrip && formMode === formModes.create && documentData.properties['sx:btBusinessTripDestination']) {
            onFormNavigate(1);
        }
    }, [documentData, formMode]);

    useEffect(() => {
        if (documentData?.type === alfrescoTypes.advanceReport) {
            if (formMode === formModes.edit &&
                documentData.properties['sx:dfState'] === documentStatuses.formationReport &&
                taskId &&
                !documentData.properties['sx:arSpending'] &&
                !documentData.properties['sx:btrNeedReport']
            ) {
                if (documentData.properties['reportForm']?.some(form => form.properties['sx:autofillObject'])) {
                    yesNoDialog(i18next.t('other.questionDialogTitle'), i18next.t('document.advanceReport.formationReportQuestion'),
                        () => {
                            const updatedData = structuredClone(documentData);
                            updatedData.properties['sx:arSpending'] = true;

                            if (updatedData.properties['sx:dfState'] === documentStatuses.formationReport && !updatedData.properties['reportForm'].some(form => !form.properties['sx:autofillObject']) && formMode === formModes.edit) {
                                if (!updatedData.properties['sx:btrNeedReport']) {
                                    updatedData.properties['reportForm'].push({
                                        type: 'sx:Report',
                                        properties: {}
                                    });

                                    setTimeout(() => {
                                        eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                                            subformName: 'routeForm',
                                            index: updatedData.properties['reportForm'].length - 1,
                                            subform: null
                                        });
                                    }, 200);
                                }
                            }

                            setDocumentData(updatedData);

                            const contentBody = {
                                properties: JSON.stringify({
                                    'sx:arSpending': true
                                }),
                                type: documentData.type
                            };
                            fetch(`/api/Document/Update/${id}`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(contentBody)
                            }).then(async (response) => {
                                if (!response.ok) {
                                    console.error('sx:arSpending updating error');
                                    console.error('status: ' + response.status);
                                }
                            });
                        },
                        () => {
                            setFormMode(formModes.edit);
                            setLoading(true);
                            submitAction(taskId, documentData.properties['sys:node-uuid'], actionTypes.approve, '', (isOk) => {
                                setLoading(false);
                                if (isOk) {
                                    navigate(urls.mainPage);
                                }
                            });
                        });
                }
            }
            else {
                if (documentData.properties['sx:dfState'] === documentStatuses.formationReport && !documentData.properties['reportForm'].some(form => !form.properties['sx:autofillObject']) && formMode === formModes.edit) {
                    if (!documentData.properties['sx:btrNeedReport']) {
                        const updatedData = structuredClone(documentData);

                        updatedData.properties['reportForm'].push({
                            type: 'sx:Report',
                            properties: {}
                        });
                        setDocumentData(updatedData);
                        setTimeout(() => {
                            eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                                subformName: 'reportForm',
                                index: updatedData.properties['reportForm'].length - 1,
                                subform: null
                            });
                        }, 200);
                    }
                }
            }
        }
    }, [formMode]);

    useEffect(() => {
        if (limitsInfo) {
            const updatedData = structuredClone(documentData);
            updateFields(updatedData);
            setDocumentData(updatedData);
        }
    }, [limitsInfo]);

    useEffect(() => {
        if (location.pathname === urls.newVacationPage) {
            setFormMode(formModes.create);
            fetch(`/api/document/GetForm?docType=${alfrescoTypes.vacationClaim}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                .then((response) => response.json())
                .then((form) => {
                    initDocumentData(form);
                    fetch('/api/account/GetVacationLimits', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                        .then((response) => response.json())
                        .then((limits) => {
                            setLimitsInfo(limits);
                        });
                });
        }
        else if (location.pathname === urls.newCertificationPage) {
            setFormMode(formModes.create);
            fetch(`/api/document/GetForm?docType=${alfrescoTypes.certification}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                .then((response) => response.json())
                .then((form) => {
                    initDocumentData(form);
                });
        }
        else if (location.pathname === urls.newBusinessTripPage) {
            setFormMode(formModes.create);
            fetch(`/api/document/GetForm?docType=${alfrescoTypes.businessTrip}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                .then((response) => response.json())
                .then((form) => {
                    initDocumentData(form);
                });
        }
        else if (location.pathname === urls.newDetailsPage) {
            setFormMode(formModes.create);
            fetch(`/api/document/GetForm?docType=${alfrescoTypes.details}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                .then((response) => response.json())
                .then((form) => {
                    initDocumentData(form);
                });
        }
        else if (location.pathname === urls.newTransferRequestPage) {
            setFormMode(formModes.create);
            fetch(`/api/document/GetForm?docType=${alfrescoTypes.transferRequest}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                .then((response) => response.json())
                .then((form) => {
                    initDocumentData(form);
                });
        }
        else {
            let id = location.pathname.split("/")[2];
            const isTask = location.pathname.startsWith(urls.tasksPage + '/');
            setIsTask(isTask);
            if (isTask) {
                setTaskId(id);
                id = searchParams.get('docId');
            }
            setId(id);

            fetch(`/api/document/get/${id}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 404) {
                        messageDialog(i18next.t('error'), i18next.t('documentNotFound'), () => { navigate(urls.documentsPage) });
                    }
                    else if (response.status === 501) {
                        response.json().then(result => {
                            if (result?.message) {
                                messageDialog(i18next.t("error"), result.message, () => {
                                    navigate(`${urls.mainPage}`);
                                });
                            }
                            else {
                                unknownErrorMessageDialog();
                            }
                        });
                    }
                    else {
                        unknownErrorMessageDialog(() => { navigate(urls.documentsPage) });
                    }
                })
                .then((data) => {
                    if (data) {
                        initDocumentData(data);
                        if (data.properties['sx:dfState'] === documentStatuses.template && (data.type === alfrescoTypes.vacationClaim || data.type === alfrescoTypes.details)) {
                            setNeedSign(true);
                        }
                        let formMode = formModes.read;
                        if (data.properties['sx:dfState'] === documentStatuses.template && data.type === alfrescoTypes.businessTrip) {
                            const id = data.properties['sys:node-uuid'];
                            let createdIds = localStorage.getItem('btCreIds')?.split(';');
                            if (createdIds && createdIds.includes(id)) {
                                formMode = formModes.edit;
                                createdIds = createdIds.filter(v => v !== id);
                                localStorage.setItem('btCreIds', createdIds.join(';'));
                                setSubmitted(false);
                                document.getElementsByClassName('main-content')[0].scrollTo({ top: 0, behavior: "smooth" });
                                eventDispatcher.invokeEvent(customEventTypes.onShowMessage, {
                                    id: v4(),
                                    title: i18next.t('notifications.documentSavedTitle'),
                                    message: i18next.t('notifications.documentSavedMessage'),
                                    type: notificationTypes.stateChanged
                                });
                            }
                        }
                        if (((data.properties['sx:dfState'] === documentStatuses.processingTravelLetterAuto || data.properties['sx:dfState'] === documentStatuses.refinementSeconded) && data.type === alfrescoTypes.travelLetterAuto) ||
                            ((data.properties['sx:dfState'] === documentStatuses.formationReport || data.properties['sx:dfState'] === documentStatuses.refinementAdvanceReport)
                                && data.type === alfrescoTypes.advanceReport)) {
                            const id = data.properties['sys:node-uuid'];
                            let editedIds = localStorage.getItem('edtIds')?.split(';');
                            if (editedIds && editedIds.includes(id)) {
                                formMode = formModes.edit;
                                editedIds = editedIds.filter(v => v !== id);
                                localStorage.setItem('edtIds', editedIds.join(';'));
                            }
                        }
                        setFormMode(formMode);
                        if (data.type === alfrescoTypes.businessTrip) {
                            setNavigationIndex(1);
                        }
                    }
                });
            getComents(id)
                .then((comments) => {
                    setComments(comments);
                });
        }
    }, [location]);

    useEffect(() => {
        documentIdRef.current = id;
        signingRef.current = signing;
    }, [id, signing])

    useEffect(() => {
        const onSignEventId = eventDispatcher.subscrubeToEvent(hubEventTypes.documentSigned, (params) => {
            if (params === documentIdRef.current) {
                setSigning(false);
                hideModalDialog('modalDialog');
                showSignStatusMessage(signStatuses.signed, () => navigate(urls.mainPage));
            }
        });
        const onSignErrorEventId = eventDispatcher.subscrubeToEvent(hubEventTypes.documentSignedError, (params) => {
            if (params === documentIdRef.current) {
                setSigning(false);
                hideModalDialog('modalDialog');
                showSignStatusMessage(signStatuses.error, () => navigate(urls.mainPage));
            }
        });
        const canceledEventId = eventDispatcher.subscrubeToEvent(hubEventTypes.documentSignCanceled, (params) => {
            if (params === documentIdRef.current) {
                setSigning(false);
                hideModalDialog('modalDialog');
                showSignStatusMessage(signStatuses.cancaled, () => navigate(urls.mainPage));
            }
        });
        const returnToPageId = eventDispatcher.subscrubeToEvent(customEventTypes.onReturnToPage, () => {
            if (signingRef.current && documentIdRef.current) {
                getSignStatus([documentIdRef.current]).then(status => {
                    if (signingRef.current && status !== signStatuses.notSigned) {
                        setSigning(false);
                        hideModalDialog('modalDialog');
                        showSignStatusMessage(status, () => {
                            navigate(urls.mainPage);
                        });
                    }
                });
            }
        });

        return () => {
            eventDispatcher.unsubscrubeFromEvent(onSignEventId);
            eventDispatcher.unsubscrubeFromEvent(onSignErrorEventId);
            eventDispatcher.unsubscrubeFromEvent(canceledEventId);
            eventDispatcher.unsubscrubeFromEvent(returnToPageId);
        }
    }, [])

    const getTaskActions = () => {
        const actions = [];
        if (documentData?.taskButtons && documentData.taskButtons[taskId]) {
            documentData.taskButtons[taskId].forEach(btn => {
                const parts = btn.split('|');
                if (parts.length >= 2) {
                    actions.push({
                        type: parts[0],
                        title: parts[1]
                    });
                }
            });
        }
        return actions
    }

    const onAssociationsChanged = (associations) => {
        setAttachmentAdded(associations.additionalDocuments?.length > 0);
    }

    const getCommentsCount = () => {
        let result = 0;
        if (comments) {
            result += comments.length;
            comments.forEach(comment => result += comment.commentBeanList ? comment.commentBeanList.length : 0);
        }
        return result;
    }

    const getActions = () => {
        const actions = [];

        if (!documentData?.type) return actions;

        if (isTask) {
            if (formMode === formModes.read) {
                if (documentData?.properties && documentData?.properties['sx:dfState'] === documentStatuses.refinement && documentData.creatorInfo.creatorNodeRef === userContext?.nodeRef) {
                    if (documentData.properties['assoc:sx:btSeconded_added'] === userContext?.nodeRef && documentData.properties['sx:btChild3Years']) {
                        actions.push({
                            title: i18next.t('sign'),
                            type: actionTypes.sign
                        });
                    }
                    else if (documentData?.taskButtons && documentData.taskButtons[taskId]?.length > 0) {
                        actions.push(...getTaskActions());
                    }
                    actions.push({
                        title: i18next.t('actions.edit'),
                        type: actionTypes.edit
                    });
                }
                else {
                    if (documentData?.taskButtons && documentData.taskButtons[taskId]?.length > 0) {
                        actions.push(...getTaskActions());
                    }
                    if (documentData?.properties && documentData?.properties['sx:dfState'] === documentStatuses.enteringInfo) {
                        actions.push({
                            title: i18next.t('actions.edit'),
                            type: actionTypes.edit
                        });
                    }
                }
            }
            else {
                if (documentData?.properties && documentData?.properties['sx:dfState'] === documentStatuses.enteringInfo) {
                    actions.push({
                        title: i18next.t('actions.save'),
                        type: actionTypes.save
                    });
                    actions.push({
                        title: i18next.t('actions.cancelation'),
                        type: actionTypes.cancelEdit
                    });
                }
                if (documentData?.properties && documentData?.properties['sx:dfState'] === documentStatuses.refinement && documentData.creatorInfo.creatorNodeRef === userContext?.nodeRef) {
                    actions.push({
                        title: i18next.t('actions.save'),
                        type: actionTypes.save
                    });
                    actions.push({
                        title: i18next.t('actions.cancelation'),
                        type: actionTypes.cancelEdit
                    });
                }
            }
        }
        if (formMode === formModes.create) {
            if (documentData?.type === alfrescoTypes.businessTrip) {
                if (navigationIndex > 0) {
                    actions.push(...createTemplateActions.filter(act => act.type !== actionTypes.save));
                }
            }
            else {
                actions.push(...createTemplateActions);
            }
        }
        else {
            if (documentData?.properties && documentData.properties['sx:dfState'] === documentStatuses.template) {
                if (documentData.creatorInfo?.creatorNodeRef !== userContext?.nodeRef) {
                    return [];
                }
            }
            switch (documentData?.type) {
                case alfrescoTypes.details:
                case alfrescoTypes.vacationClaim: {
                    if (documentData?.properties['sx:dfState'] === documentStatuses.template && formMode === formModes.read) {
                        actions.push({
                            title: i18next.t('actions.edit'),
                            type: actionTypes.edit
                        });
                    }
                    if (documentData?.properties['sx:dfState'] === documentStatuses.template && formMode === formModes.edit) {
                        actions.push({
                            title: i18next.t('actions.save'),
                            type: actionTypes.save
                        });
                        actions.push({
                            title: i18next.t('actions.cancelation'),
                            type: actionTypes.cancelEdit
                        });
                    }
                    if (formMode === formModes.read && needSign) {
                        actions.push(...signTemplateActions);
                    }
                    break;
                }
                case alfrescoTypes.certification:
                case alfrescoTypes.transferRequest: {
                    if (documentData?.properties['sx:dfState'] === documentStatuses.template || documentData?.properties['sx:dfState'] === documentStatuses.preparing) {
                        if (formMode === formModes.read) {
                            actions.push({
                                title: i18next.t('actions.send'),
                                type: actionTypes.send
                            });
                            actions.push({
                                title: i18next.t('actions.edit'),
                                type: actionTypes.edit
                            });
                            actions.push({
                                title: i18next.t('actions.cancel'),
                                type: actionTypes.delete
                            });
                        }
                        if (formMode === formModes.edit) {
                            actions.push({
                                title: i18next.t('actions.save'),
                                type: actionTypes.save
                            });
                            actions.push({
                                title: i18next.t('actions.cancelation'),
                                type: actionTypes.cancelEdit
                            });
                        }
                    }
                    break;
                }
                case alfrescoTypes.businessTrip: {
                    if (formMode === formModes.read && documentData.properties['sx:dfState'] === documentStatuses.template) {
                        if (documentData.creatorInfo?.creatorNodeRef === userContext?.nodeRef) {
                            actions.push({
                                title: i18next.t('actions.edit'),
                                type: actionTypes.edit
                            });
                            actions.push({
                                title: i18next.t('actions.cancel'),
                                type: actionTypes.delete
                            });
                            if (navigationIndex === 4) {
                                let isNeedSign = documentData?.properties['sx:btChild3Years'];
                                if (!isNeedSign) {
                                    if (documentData?.properties['sx:btMainPlace'] === false) {
                                        const form = documentData.properties['routeForm'];
                                        if (form && form.length > 0) {
                                            isNeedSign = form[0].properties['sx:pbtMethodTransportation'] === transportationMethods.bus || form[0].properties['sx:pbtMethodTransportation'] === transportationMethods.train || form[0].properties['sx:pbtMethodTransportation'] === transportationMethods.plane;
                                        }
                                    }
                                }
                                if (isNeedSign && documentData?.properties['assoc:sx:btSeconded_added'] === userContext?.nodeRef) {
                                    actions.push({
                                        title: i18next.t('sign'),
                                        type: actionTypes.sign
                                    });
                                }
                                else {
                                    actions.push({
                                        title: i18next.t('actions.sendBusinessTrip'),
                                        type: actionTypes.send
                                    });
                                }
                            }
                        }
                    }
                    if (formMode === formModes.edit && documentData?.properties && documentData?.properties['sx:dfState'] === documentStatuses.template) {
                        if (documentData.creatorInfo?.creatorNodeRef === userContext?.nodeRef) {
                            actions.push({
                                title: i18next.t('actions.cancelation'),
                                type: actionTypes.cancelEdit
                            });
                            actions.push({
                                title: i18next.t('actions.cancel'),
                                type: actionTypes.delete
                            });
                        }
                    }
                    break;
                }
                case alfrescoTypes.travelLetterAuto: {
                    if (documentData.properties['sx:dfState'] === documentStatuses.processingTravelLetterAuto || documentData.properties['sx:dfState'] === documentStatuses.refinementSeconded) {
                        if (formMode === formModes.read) {
                            actions.push({
                                title: i18next.t('actions.edit'),
                                type: actionTypes.edit
                            });
                        }
                        if (formMode === formModes.edit) {
                            actions.push({
                                title: i18next.t('actions.save'),
                                type: actionTypes.save
                            });
                            actions.push({
                                title: i18next.t('actions.cancelation'),
                                type: actionTypes.cancelEdit
                            });
                        }
                    }
                    break;
                }
                case alfrescoTypes.advanceReport: {
                    if (documentData.properties['sx:dfState'] === documentStatuses.formationReport || documentData.properties['sx:dfState'] === documentStatuses.refinementAdvanceReport) {
                        if (formMode === formModes.read) {
                            actions.push({
                                title: i18next.t('actions.edit'),
                                type: actionTypes.edit
                            });
                        }
                        if (formMode === formModes.edit) {
                            actions.push({
                                title: i18next.t('actions.save'),
                                type: actionTypes.save
                            });
                            actions.push({
                                title: i18next.t('actions.cancelation'),
                                type: actionTypes.cancelEdit
                            });
                        }
                    }
                    break;
                }
            }
        }
        return actions;
    }

    const actions = getActions();
    let hasActionBtns = actions.length > 0;
    let actionCount = actions.length;

    const renderActions = (className = "") => {
        if (actions.length > 0) {
            return <ActionsMenu key="actions-menu" className={className} actions={actions} onItemClick={onAction} disabled={loading} />;
        }
        else {
            return <></>;
        }
    }

    const showFileContentForm = () => {
        switch (documentData?.type) {
            case alfrescoTypes.details:
            case alfrescoTypes.vacationClaim:
            case alfrescoTypes.transferRequest:
                return formMode === formModes.read && tabKey === documentTabKeys.general;
            case alfrescoTypes.certification:
                return formMode === formModes.read && tabKey === documentTabKeys.general
                    && (documentData.properties['sx:dfDocKind'] === certificationKinds.characteristic || documentData.properties['sx:dfState'] === documentStatuses.archived || documentData.properties['sx:dfState'] === documentStatuses.sending);
            case alfrescoTypes.travelLetterAuto:
                return formMode === formModes.read && tabKey === documentTabKeys.general && documentData.associations?.mainContent?.length > 0;
            case alfrescoTypes.advanceReport:
                return formMode === formModes.read && tabKey === documentTabKeys.general && documentData.associations?.mainContent?.length > 0;
            case alfrescoTypes.unstructuredDocument:
                return true;
            default:
                return false;
        }
    }

    const onFormNavigate = (index) => {
        if (loading) return;
        if (index < navigationIndex || formMode === formModes.read || (documentData.properties['sx:dfState'] !== documentStatuses.template && documentData.properties['sx:dfState'] !== documentStatuses.refinement)) {
            setSubmitted(false);
            setNavigationIndex(index);
            document.getElementsByClassName('main-content')[0].scrollTo({ top: 0, behavior: "smooth" });
        }
        else {
            const checkResult = checkInputPage();
            if (checkResult.success) {
                if (!loading) {
                    if (formMode === formModes.edit) {
                        if (documentWasUpdated) {
                            submit((id) => {
                                setSubmitted(false);
                                document.getElementsByClassName('main-content')[0].scrollTo({ top: 0, behavior: "smooth" });
                                eventDispatcher.invokeEvent(customEventTypes.onShowMessage, {
                                    id: v4(),
                                    title: i18next.t('notifications.documentSavedTitle'),
                                    message: i18next.t('notifications.documentSavedMessage'),
                                    type: notificationTypes.stateChanged
                                });

                                fetch(`/api/document/get/${id}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                                    .then((response) => {
                                        if (response.ok) {
                                            return response.json();
                                        }
                                        else if (response.status === 404) {
                                            messageDialog(i18next.t('error'), i18next.t('documentNotFound'), () => { navigate(urls.documentsPage) });
                                            setSaving(false);
                                            setLoading(false);
                                        }
                                        else {
                                            unknownErrorMessageDialog(() => { navigate(urls.documentsPage) });
                                        }
                                    })
                                    .then((data) => {
                                        if (data) {
                                            setDocumentWasUpdated(false);
                                            initDocumentData(data);
                                            setSaving(false);
                                            setLoading(false);
                                            setNavigationIndex(index);
                                            if (index === 4) {
                                                setDocumentWasUpdated(false);
                                                setFormMode(formModes.read);
                                            }
                                        }
                                    });
                            });
                        }
                        else if (index === 4) {
                            setNavigationIndex(index);
                            setDocumentWasUpdated(false);
                            setFormMode(formModes.read);
                            setSaving(false);
                            setLoading(false);
                        }
                        else {
                            setSaving(false);
                            setLoading(false);
                            setNavigationIndex(index);
                        }
                    }
                    else if (formMode === formModes.create) {
                        setSubmitted(false);
                        submit((id) => {
                            let createdIds = localStorage.getItem('btCreIds')?.split(';');
                            if (!createdIds) {
                                createdIds = [];
                            }
                            createdIds.push(id);
                            localStorage.setItem('btCreIds', createdIds.join(';'));

                            const returnParam = searchParams.get('return');
                            navigate(`${urls.documentsPage}/${id}?return=${returnParam ? returnParam : urls.documentsPage}`);
                        });
                    }
                    else {
                        setSubmitted(false);
                        setNavigationIndex(index);
                        document.getElementsByClassName('main-content')[0].scrollTo({ top: 0, behavior: "smooth" });
                    }
                }
            }
            else {
                setSubmitted(true);
            }
        }
    }

    const isNeedShowAccordion = () => {
        if (documentData?.type === alfrescoTypes.travelLetterAuto) {
            return documentData.associations?.mainContent?.length > 0 && hasSignBtn && formMode === formModes.read;
        }
        else if (documentData?.type === alfrescoTypes.businessTrip) {
            return false;
        }
        else {
            return needSign || hasSignBtn;
        }
    }

    // На останньому кроці замість «Продовжити» показуються кнопки погодження і редагування
    const lastNavigationIndex = (documentData?.form?.navigation?.length ?? 0) - 1;
    const isBusinessTrip = documentData?.type === alfrescoTypes.businessTrip;
    const showTripActions = isBusinessTrip && tabKey === documentTabKeys.general && navigationIndex > 0 && (documentData?.properties['sx:dfState'] === documentStatuses.template || documentData?.properties['sx:dfState'] === documentStatuses.refinement);
    // Погодження відрядження керівником: замість майстра з кроками показується коротка
    // картка з полями, потрібними для рішення. Тільки для цього завдання і тільки для
    // заявки на відрядження — решта документів і станів лишаються без змін
    const isTripTask = isBusinessTrip && isTask && documentData?.properties['sx:dfState'] !== documentStatuses.refinement;
    const isLastNavigationIndex = navigationIndex === lastNavigationIndex;

    // Скасування відрядження живе в шапці поруч із закриттям. Умови показу ті самі, що були
    // в блоці дій: showTripActions раніше давав його обгортці, тому тут він заданий явно.
    const tripCancelBtn = showTripActions && actions.some(a => a.type === actionTypes.delete) &&
        <Button className="trip-cancel-btn" onClick={() => { onAction(actionTypes.delete); }}>
            {i18next.t('actions.cancel')}
        </Button>;

    // Повернення на цей документ після переходу за посиланням залежить від того, відкритий
    // він як завдання чи як документ — сам адресат посилання від цього не змінюється
    const getDocumentLinkHref = (nodeRef) => {
        const returnUrl = isTask ? `${urls.tasksPage}/${taskId}?docId=${id}` : `${urls.documentsPage}/${id}`;
        return `${urls.documentsPage}/${nodeRef.split('/').pop()}?return=${returnUrl}`;
    }
    // Документи, сформовані за відрядженням. Показуються на останньому кроці під підсумком —
    // картками того ж вигляду, що й список доданих файлів
    const tripRelatedDocs = [
        { key: 'travelLetterAuto', nodeRef: documentData?.associations?.travelLetterAuto?.[0], title: i18next.t('document.travelLetterAutoLinkTitle') },
        { key: 'advanceReport', nodeRef: documentData?.associations?.advanceReport?.[0], title: i18next.t('document.advanceReportLinkTitle') }
    ].filter(item => item.nodeRef);

    const documentHeader = <DocumentHeader key="doc-header" title={documentData?.title} type={props.listType}>
        {tripCancelBtn}
    </DocumentHeader>;
    // Вкладки «Загальне / Коментарі» у відрядженні живуть у липкій шапці над кроками. Під час
    // створення коментувати ще нічого, а єдина вкладка «Загальне» була б зайвою
    const tripTabs = isBusinessTrip && formMode !== formModes.create &&
        <DocumentTabs key="trip-tabs" onItemClick={onTabChanged} formMode={formMode} commentsCount={getCommentsCount()} />;
    // Кнопки чернетки (Template) належать майстру з кроками й показуються лише на вкладці
    // «Загальне»; на «Коментарях» їх не видно, як і самих кроків
    const hideTripActionsOnComments = isBusinessTrip && tabKey === documentTabKeys.comments
        && documentData?.properties['sx:dfState'] === documentStatuses.template;
    const tripHeader = isBusinessTrip && tabKey === documentTabKeys.general && navigationIndex > 0 && !isTripTask &&
        <div className="business-trip-header" key="trip-header">
            {documentData.properties && documentData.properties['sx:btBusinessTripDestination'] === tripDestinations.ukraine && <RouteTypeSwitcher name={'sx:btMultipleRoutes'} value={documentData.properties['sx:btMultipleRoutes']} disabled={formMode === formModes.read} onChange={inputChangeHandler} />}
            {documentData?.form?.navigation && (documentData?.properties['sx:dfState'] !== documentStatuses.processing || !isTask) && <FormNavigation items={documentData.form.navigation} activeIndex={navigationIndex} hideBtns={true} onNavigate={onFormNavigate} />}
        </div>;

    return ([<div className={"document" + (hasActionBtns ? " with-actions" : "") + (actionCount > 2 ? " more-then-2-actions" : "") + (actionCount === 2 ? " two-actions" : "")
        + (showTripActions ? (isLastNavigationIndex ? " with-two-trip-actions" : " with-trip-actions") : "")
        + (isBusinessTrip ? " business-trip" : "")} key="document">
        {/* у відрядженні шапка з кроками зафіксована вгорі, тому лежить в одній липкій обгортці */}
        {isBusinessTrip
            ? <div className="business-trip-sticky" key="trip-sticky">{documentHeader}{tripTabs}{tripHeader}</div>
            : documentHeader}
        {!isBusinessTrip && documentData?.type !== alfrescoTypes.travelLetterAuto && documentData?.type !== alfrescoTypes.advanceReport && renderActions()}
        {documentData?.type && !isBusinessTrip && <DocumentTabs onItemClick={onTabChanged} formMode={formMode} commentsCount={getCommentsCount()} />}
        <div className="doc-content">
            {tabKey === documentTabKeys.general && documentData.form && (isTripTask
                ? <div className="document-form businessTrip" key="doc-general">
                    <TripTaskForm properties={documentData.properties} fields={documentData.form.fields}
                        showDocuments={documentData.properties['sx:dfState'] === documentStatuses.signingSeconded || documentData.properties['sx:dfState'] === documentStatuses.approvingSeconded} />
                </div>
                : <DocumentForm key="doc-general" isTask={isTask} form={documentData.form} formMode={loading ? formModes.read : formMode} properties={documentData.properties} onChange={inputChangeHandler} submitted={submitted} showAccordion={isNeedShowAccordion()} type={documentData.type} id={id} navigationIndex={navigationIndex} formError={formError} />)}
            {tabKey === documentTabKeys.comments && documentData.properties && <CommentsForm key="doc-comments" comments={comments} documentId={documentData.properties["sys:node-uuid"]} onCommentChanged={setComments} />}
            {showFileContentForm() && <FileContentForm associations={documentData?.associations} docId={id} canAdd={canAddFiles} onAssociationsChanged={onAssociationsChanged} hideLoader={loading} selectedIndex={isTask && documentData?.type === alfrescoTypes.vacationClaim && documentData.properties['sx:dfState'] === documentStatuses.signingOrderEmployee ? 1 : 0} />}
        </div>
        {tabKey === documentTabKeys.general && documentData?.type === alfrescoTypes.businessTrip && navigationIndex === 4 && tripRelatedDocs.length > 0 &&
            <div className='document-form trip-related-docs'>
                <div className='trip-related-docs-title'>{i18next.t('document.tripRelatedDocsHeader')}</div>
                {tripRelatedDocs.map(item =>
                    <a className='trip-related-doc' key={item.key} target={'_blank'} href={getDocumentLinkHref(item.nodeRef)}>
                        <DocIcon />
                        <span className='trip-related-doc-name'>{item.title}</span>
                        <ChevronRightIcon />
                    </a>
                )}
            </div>
        }
        {tabKey === documentTabKeys.general && (documentData?.type === alfrescoTypes.travelLetterAuto || documentData?.type === alfrescoTypes.advanceReport) &&
            documentData.associations?.relatedBusinessTrip?.length > 0 &&
            <div className='document-form document-link-form'>
                {isTask && <a className='form-link' target={'_blank'} href={`${urls.documentsPage}/${documentData.associations.relatedBusinessTrip[0].split('/').pop()}?return=${urls.tasksPage}/${taskId}?docId=${id}`}>{i18next.t('document.businessTripLinkTitle')}</a>}
                {!isTask && <a className='form-link' target={'_blank'} href={`${urls.documentsPage}/${documentData.associations.relatedBusinessTrip[0].split('/').pop()}?return=${urls.documentsPage}/${id}`}>{i18next.t('document.businessTripLinkTitle')}</a>}
            </div>
        }
        {(documentData?.type === alfrescoTypes.businessTrip || documentData?.type === alfrescoTypes.travelLetterAuto || documentData?.type === alfrescoTypes.advanceReport) && !showTripActions && !hideTripActionsOnComments && renderActions("bottom")}
        {loading && <Spinner animation="border" variant="primary" />}
    </div>,
    !showTripActions && !hideTripActionsOnComments && <div className="mobile-actions" key="mobile-actions">
        {renderActions()}
    </div>,
    // поза .document, бо його backdrop-filter став би системою координат для position: fixed
    showTripActions && <div className="business-trip-actions" key="trip-actions">
        {isLastNavigationIndex && actions?.some(a => a.type === actionTypes.sign) && <>
            <Button className="trip-primary-btn" onClick={() => onAction(actionTypes.sign)}>
                {i18next.t('sign')}<SendIcon />
            </Button>
        </>}
        {isLastNavigationIndex && actions?.some(a => a.type === actionTypes.send) && <>
            <Button className="trip-primary-btn" onClick={() => onAction(actionTypes.send)}>
                {i18next.t('document.businessTripApprovalBtn')}<SendIcon />
            </Button>
        </>}
        {formMode === formModes.read && actions.some(a => a.type === actionTypes.approve) && <Button className="trip-primary-btn" onClick={() => onAction(actionTypes.approve)}>
            {i18next.t('document.businessTripApprovalBtn')}<SendIcon />
        </Button>}
        {formMode === formModes.read && actions.some(a => a.type === actionTypes.edit) && <Button className="trip-outline-btn" onClick={() => { onFormNavigate(1); setFormMode(formModes.edit); }}>
            {i18next.t('document.businessTripEditBtn')}<PencilIcon />
        </Button>}
        {formMode !== formModes.read && !isLastNavigationIndex && <Button className="trip-primary-btn" onClick={() => onFormNavigate(navigationIndex + 1)}>
            {i18next.t('document.businessTripContinueBtn')}
        </Button>}
    </div>
    ]);
}

export default Document;